import React, { useEffect, useRef, useState, useMemo } from "react";
import maplibregl from "maplibre-gl";
import { withIdentityPoolId } from "@aws/amazon-location-utilities-auth-helper/dist/amazonLocationAuthHelper";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, useParams, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Helmet, HelmetProvider } from "react-helmet-async";
import emailjs from 'emailjs-com';
import InstagramEmbedSimple from './InstagramEmbedSimple';
import XEmbedSimple from './XEmbedSimple';
import Articles from './Articles';
import ArticleDetail from './ArticleDetail';
import 'maplibre-gl/dist/maplibre-gl.css';
import SignUp from './SignUp';
import Login from './Login';
import Profile from './Profile';
import { auth } from "./firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { Link } from "react-router-dom";
import { doc, getDoc, updateDoc, arrayUnion, arrayRemove, onSnapshot } from "firebase/firestore";
import { db } from "./firebase";
import Supercluster from "supercluster";
import SignInPromptModal from './SignInPromptModal';
import TermsOfService from './TermsOfService';
import PrivacyPolicy from './PrivacyPolicy';
import CookiesPolicy from './CookiesPolicy';
import PublicProfile from './PublicProfile';
import AddToListDropdown from './components/AddToListDropdown';
import LocationSearchBar from './components/LocationSearchBar';
import CourseReviews from './components/CourseReviews';
import AdminMediaModal from './components/AdminMediaModal';
import AdminCourseGuidesModal from './components/AdminCourseGuidesModal';
import { getAllMedia, getMediaByCourseId, checkIsAdmin } from './services/mediaService';
import { getAllCourseGuides } from './services/courseGuidesService';

const identityPoolId = "us-east-2:1ad463b2-bdaa-46ff-90e0-2267bbbf7a1d";
const mapName = "golfmap-v1";
const region = "us-east-2";

// Add this at the top of the file, outside the  App component
const BAD_LINKS = [
  "oldeoaksgolfclub.com",
  "gardenvalleytx.com",
  // Add more as needed
];

const featuredMediaTypes = ['Design Disasters', 'Fried Egg Golf'];

function isBadLink(url) {
  if (!url) return false;
  // Normalize: remove protocol and the trailing slashes
  const normalized = url.replace(/^https?:\/\//, '').replace(/\/$/, '').toLowerCase();
  return BAD_LINKS.some(bad => normalized.startsWith(bad));
}

// Utility to check if a course has media
function courseHasMedia(course, mediaList) {
  return mediaList && mediaList.some(m => m.course_id === course.course_id);
}

// Utility to fix mojibake (encoding issues)
function fixMojibake(str) {
  if (!str) return str;
  return str
    .replace(/â€" /g, '–')
    .replace(/â€" /g, '—')
    .replace(/â€˜/g, '‘')
    .replace(/â€™/g, '’')
    .replace(/â€œ/g, '“')
    .replace(/â€/g, '”')
    .replace(/â€¦/g, '…')
    .replace(/â€¢/g, '•')
    .replace(/Â/g, '');
}

// Add this new component near the top of the file, after the other modal components
function ShareModal({ isOpen, onClose, url }) {
  const [showCopiedTooltip, setShowCopiedTooltip] = useState(false);

  const handleCopy = () => {
    // Create a temporary input element
    const tempInput = document.createElement('input');
    tempInput.value = url;
    document.body.appendChild(tempInput);
    
    // Select and copy the text
    tempInput.select();
    tempInput.setSelectionRange(0, 99999); // For mobile devices
    
    try {
      // Try using the modern clipboard API first
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(url).then(() => {
          setShowCopiedTooltip(true);
          setTimeout(() => setShowCopiedTooltip(false), 2000);
        });
      } else {
        // Fallback for older browsers and non-secure contexts
        document.execCommand('copy');
        setShowCopiedTooltip(true);
        setTimeout(() => setShowCopiedTooltip(false), 2000);
      }
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
    
    // Clean up
    document.body.removeChild(tempInput);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose} style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div className="modal-content" onClick={e => e.stopPropagation()} style={{
        background: 'white',
        padding: '24px',
        borderRadius: '12px',
        width: '90%',
        maxWidth: '400px',
        position: 'relative'
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 12,
            right: 12,
            background: 'none',
            border: 'none',
            fontSize: '24px',
            color: '#888',
            cursor: 'pointer',
            padding: 0,
            lineHeight: 1
          }}
          aria-label="Close"
        >
          ×
        </button>
        <h2 style={{ margin: '0 0 16px 0', fontSize: '20px', color: '#333' }}>Share Course</h2>
        <div style={{ marginBottom: '20px' }}>
          <div style={{ 
            background: '#f5f5f5', 
            padding: '12px', 
            borderRadius: '8px',
            wordBreak: 'break-all',
            fontSize: '14px',
            color: '#666',
            marginBottom: '12px'
          }}>
            {url}
          </div>
          <button
            onClick={handleCopy}
            style={{
              width: '100%',
              background: '#1D665D',
              color: 'white',
              border: 'none',
              padding: '10px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              position: 'relative'
            }}
          >
            {showCopiedTooltip ? 'Copied!' : 'Copy Link'}
            {showCopiedTooltip && (
              <div style={{
                position: 'absolute',
                bottom: '100%',
                left: '50%',
                transform: 'translateX(-50%)',
                background: '#333',
                color: 'white',
                padding: '4px 8px',
                borderRadius: '4px',
                fontSize: '12px',
                whiteSpace: 'nowrap',
                marginBottom: '8px'
              }}>
                Link copied!
              </div>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

// Add this new Tooltip component for marker hover
function MarkerTooltip({ tooltipInfo, isMobile, onTitleClick, courseGuides, onMouseLeave, onMouseEnter }) {
  if (!tooltipInfo || !tooltipInfo.position) return null;

  const { course, position } = tooltipInfo;

  const formatYear = (year) => {
    if (!year || year === 'N/D' || year === '') return 'Year Unknown';
    return year;
  };

  const formatHoles = (holes) => {
    if (!holes) return 'Holes Unknown';
    return holes >= 18 ? '18 Holes' : `${holes} Holes`;
  };

  const formatArchitect = (architect) => {
    if (!architect || architect === 'N/D' || architect === '') return null;
    return architect;
  };

  const rankedText = course.top100_state_rank && course.top100_state_rank !== '' 
    ? `#${course.top100_state_rank} in ${course.state}` 
    : null;
    
  const nationalRankedText = course.GD100all_rank && course.GD100all_rank !== '' 
    ? `#${course.GD100all_rank} in America` 
    : null;
    
  const publicRankedText = course.GD100pub_rank && course.GD100pub_rank !== '' 
    ? `#${course.GD100pub_rank} Public in America` 
    : null;

  const titleStyles = { 
    fontWeight: '700', 
    color: '#222', 
    fontSize: '14px',
    marginBottom: '4px',
    wordBreak: 'break-word'
  };

  const linkStyles = {
    ...titleStyles,
    background: 'none',
    border: 'none',
    padding: 0,
    margin: 0,
    font: 'inherit',
    color: '#1D665D',
    textDecoration: 'underline',
    cursor: 'pointer',
    textAlign: 'left'
  };

  return (
    <div
      className="marker-tooltip"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        position: 'absolute',
        left: position?.x ?? 0,
        top: position?.y ?? 0,
        transform: 'translate(-50%, -100%) translateY(120px)',
        background: 'white',
        border: '1px solid #ddd',
        borderRadius: '8px',
        padding: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        zIndex: 1000,
        maxWidth: '280px',
        minWidth: '200px',
        pointerEvents: 'auto',
        fontSize: '13px',
        lineHeight: '1.4'
      }}
    >
      {/* Arrow pointing down to marker */}
      <div style={{
        position: 'absolute',
        bottom: '-6px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: 0,
        height: 0,
        borderLeft: '6px solid transparent',
        borderRight: '6px solid transparent',
        borderTop: '6px solid white',
        filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.1))'
      }} />
      
      {/* First Row: Course Name (clickable on mobile) */}
      {isMobile ? (
        <button onClick={() => onTitleClick(course)} style={linkStyles}>
          {course.name}
        </button>
      ) : (
        <div style={titleStyles}>
          {course.name}
        </div>
      )}
      
      {/* Second Row: Club Name */}
      <div style={{ 
        color: '#666', 
        fontSize: '13px',
        marginBottom: '6px',
        fontStyle: 'italic'
      }}>
        {course.club_name}
      </div>
      
      {/* Third Row: Ranking and Notable Architect */}
      <div style={{ 
        display: 'flex', 
        flexWrap: 'wrap', 
        gap: '8px', 
        marginBottom: '8px',
        fontSize: '12px',
        color: '#1D665D',
        fontWeight: '600'
      }}>
        {nationalRankedText && (
          <span>{nationalRankedText}</span>
        )}
        {publicRankedText && (
          <>
            {nationalRankedText && <span>•</span>}
            <span>{publicRankedText}</span>
          </>
        )}
        {rankedText && (
          <>
            {(nationalRankedText || publicRankedText) && <span>•</span>}
            <span>{rankedText}</span>
          </>
        )}

      </div>
      
      {/* Appears in Guide (if applicable) */}
      {courseGuides.some(guide => guide.course_id === course.course_id) && (
        <div style={{ 
          color: '#1D665D', 
          fontSize: '12px',
          fontWeight: '600',
          marginBottom: '4px'
        }}>
          Appears in{' '}
          {courseGuides
            .filter(guide => guide.course_id === course.course_id)
            .filter((guide, index, self) => 
              index === self.findIndex(g => g.guide === guide.guide)
            )
            .map((guide, index) => (
              <span key={`${guide.course_id}-${guide.guide}-${index}`}>
                {index > 0 && ', '}
                <a 
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    const url = guide.link.match(/^https?:\/\//i) ? guide.link : `https://${guide.link}`;
                    window.open(url, '_blank');
                  }}
                  style={{ color: '#1D665D', textDecoration: 'underline', cursor: 'pointer' }}
                >
                  {guide.guide}
                </a>
              </span>
            ))}
        </div>
      )}
      
      {/* Review Count (if available) */}
      {course.reviewCount > 0 && (
        <div style={{ 
          color: '#1D665D', 
          fontSize: '12px',
          fontWeight: '600',
          marginBottom: '4px'
        }}>
          {course.reviewCount} review{course.reviewCount !== 1 ? 's' : ''}
        </div>
      )}
      
      {/* Fourth Row: Details */}
      <div style={{ 
        color: '#555', 
        fontSize: '12px',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px'
      }}>
        <span>{course.type}</span>
        <span>•</span>
        <span>{formatYear(course.open_date)}</span>
        <span>•</span>
        <span>{formatHoles(course.number_of_holes)}</span>
        {formatArchitect(course.course_architect) && (
          <>
            <span>•</span>
            <span style={{
              fontWeight: course.notable_architect && course.notable_architect !== 'N' ? '700' : '400',
              color: course.notable_architect && course.notable_architect !== 'N' ? '#1D665D' : '#555'
            }}>
              {formatArchitect(course.course_architect)}
            </span>
          </>
        )}
      </div>
    </div>
  );
}

function FeaturedCard({ course, onClose, markersRef, user, playedCourses, onPlayedChange, wishlistCourses, onWishlistChange, clusters, findClusterForCourse, getMarkerElementForCourse, isMobile, courseGuides }) {
  const [showShareModal, setShowShareModal] = useState(false);

  // Add useEffect to maintain marker highlight using the shared cluster-finding logic
  useEffect(() => {
    if (!course || !markersRef.current || !clusters) return;

    const markerElement = getMarkerElementForCourse(course);
    
    if (markerElement) {
      // Reset all other markers to default style
      Object.entries(markersRef.current).forEach(([name, { element }]) => {
        if (element && element !== markerElement) {
          const markerPhotoUrl = element.querySelector('img')?.src;
          element.style.boxShadow = markerPhotoUrl ? "0 2px 8px rgba(0,0,0,0.18)" : "0 2px 8px rgba(0,0,0,0.18)";
        }
      });
      // Highlight the selected marker directly
      markerElement.style.boxShadow = "0 0 0 4px #1D665D, 0 2px 8px rgba(0,0,0,0.18)";
    }

    return () => {
      // Clean up - reset the marker style when the card is closed
      if (markerElement) {
        const markerPhotoUrl = markerElement.querySelector('img')?.src;
        markerElement.style.boxShadow = markerPhotoUrl ? "0 2px 8px rgba(0,0,0,0.18)" : "0 2px 8px rgba(0,0,0,0.18)";
      }
    };
  }, [course, clusters, getMarkerElementForCourse]);

  if (!course) return null;
  return (
    <div className="featured-card">
      {/* Only show the X button in the upper right on desktop */}
      {onClose && !isMobile && (
        <button
          className="featured-card-close"
          onClick={onClose}
          aria-label="Close featured card"
          style={{ position: 'absolute', top: 8, right: 12, background: 'none', border: 'none', fontSize: '1.5rem', color: '#888', cursor: 'pointer', zIndex: 10 }}
        >
          ×
        </button>
      )}
      {/* Course Name - Hyperlinked */}
      <h3 style={{ 
        fontWeight: '700', 
        color: '#222', 
        fontSize: '16px',
        marginBottom: '4px',
        wordBreak: 'break-word'
      }}>
        <a 
          href={`/course/${course.course_id}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ 
            color: '#1D665D', 
            textDecoration: 'underline',
            cursor: 'pointer'
          }}
          onMouseEnter={(e) => {
            e.target.style.opacity = '0.8';
          }}
          onMouseLeave={(e) => {
            e.target.style.opacity = '1';
          }}
        >
          {course.name}
        </a>
      </h3>
      
      {/* Club Name */}
      <div style={{ 
        color: '#666', 
        fontSize: '13px',
        marginBottom: '6px',
        fontStyle: 'italic'
      }}>
        {course.club_name}
      </div>
      {/* State Ranking and Notable Architect Row */}
      <div style={{ 
        display: 'flex', 
        flexWrap: 'wrap', 
        gap: '8px', 
        marginBottom: '8px',
        fontSize: '12px',
        color: '#1D665D',
        fontWeight: '600'
      }}>
        {course.GD100all_rank && course.GD100all_rank !== '' && (
          <span>#{course.GD100all_rank} in America</span>
        )}
        {course.GD100pub_rank && course.GD100pub_rank !== '' && (
          <>
            {course.GD100all_rank && course.GD100all_rank !== '' && <span>•</span>}
            <span>#{course.GD100pub_rank} Public in America</span>
          </>
        )}
        {course.top100_state_rank && course.top100_state_rank !== '' && (
          <>
            {(course.GD100all_rank && course.GD100all_rank !== '') || (course.GD100pub_rank && course.GD100pub_rank !== '') ? <span>•</span> : null}
            <span>#{course.top100_state_rank} in {course.state}</span>
          </>
        )}

      </div>
      
      {/* Top100 Description (if applicable) */}
      {course.top100_desc && (
        <>
          <div style={{ 
            color: '#444', 
            fontSize: '14px',
            marginBottom: '4px',
            lineHeight: '1.4'
          }}>
            {fixMojibake(course.top100_desc)}
          </div>
          <div style={{ 
            fontSize: '11px', 
            color: '#888', 
            marginBottom: '8px'
          }}>
            Source: <a href="https://www.top100golfcourses.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#888', textDecoration: 'underline' }}>top100golfcourses.com</a>
          </div>
        </>
      )}
      {/* Appears in Guide (if applicable) */}
      {courseGuides && courseGuides.some(guide => guide.course_id === course.course_id) && (
        <div style={{ 
          color: '#1D665D', 
          fontSize: '12px',
          fontWeight: '600',
          marginBottom: '8px'
        }}>
          Appears in{' '}
          {courseGuides
            .filter(guide => guide.course_id === course.course_id)
            .filter((guide, index, self) => 
              index === self.findIndex(g => g.guide === guide.guide)
            )
            .map((guide, index) => (
              <span key={`${guide.course_id}-${guide.guide}-${index}`}>
                {index > 0 && ', '}
                <a 
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    const url = guide.link.match(/^https?:\/\//i) ? guide.link : `https://${guide.link}`;
                    window.open(url, '_blank');
                  }}
                  style={{ color: '#1D665D', textDecoration: 'underline', cursor: 'pointer' }}
                >
                  {guide.guide}
                </a>
              </span>
            ))}
        </div>
      )}
      
      {/* Review Count (if available) */}
      {course.reviewCount > 0 && (
        <div style={{ 
          color: '#1D665D', 
          fontSize: '12px',
          fontWeight: '600',
          marginBottom: '8px'
        }}>
          {course.reviewCount} review{course.reviewCount !== 1 ? 's' : ''}
        </div>
      )}
      
      {/* Course Details Row */}
      <div style={{ 
        display: 'flex', 
        flexWrap: 'wrap', 
        gap: '8px', 
        marginTop: '12px',
        marginBottom: '8px',
        fontSize: '12px',
        color: '#666'
      }}>
        {course.type && (
          <span>{course.type}</span>
        )}
        {course.open_date && (
          <>
            {course.type && <span>•</span>}
            <span>{course.open_date}</span>
          </>
        )}
        {course.number_of_holes && (
          <>
            {(course.type || course.open_date) && <span>•</span>}
            <span>{course.number_of_holes >= 18 ? '18' : course.number_of_holes} Holes</span>
          </>
        )}
        {course.course_architect && course.course_architect !== 'N' && (
          <>
            {(course.type || course.open_date || course.number_of_holes) && <span>•</span>}
            <span style={{
              fontWeight: course.notable_architect && course.notable_architect !== 'N' ? '700' : '400',
              color: course.notable_architect && course.notable_architect !== 'N' ? '#1D665D' : '#555'
            }}>
              {course.course_architect}
            </span>
          </>
        )}
      </div>
      
      {/* Price Display */}
      {course.price && course.price !== '$Unk' && (
        <div style={{ 
          fontSize: '16px',
          fontWeight: '700',
          color: '#1D665D',
          marginBottom: '16px'
        }}>
          {course.price}
        </div>
      )}
      
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, marginTop: 24, width: isMobile ? '90%' : '100%' }}>
        <div style={{ display: 'flex', gap: 8 }}>
          {/* Add to List Dropdown - positioned at bottom left */}
          {user && (
            <AddToListDropdown 
              courseId={course.course_id}
              isMobile={isMobile}
              onListsUpdate={(updatedLists) => {
                // This will be handled by the dropdown component itself
              }}
            />
          )}
          {/* Only show the gray Close button at the bottom left, not at the top */}
          {onClose && (
            <button
              onClick={onClose}
              style={{
                background: '#e0e0e0',
                color: '#333',
                border: 'none',
                padding: '8px 16px',
                borderRadius: 12,
                cursor: 'pointer',
                fontSize: 14,
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                gap: 6
              }}
            >
              Close
            </button>
          )}
        </div>
        <button
          onClick={() => setShowShareModal(true)}
          style={{
            background: '#1D665D',
            color: 'white',
            border: 'none',
            padding: isMobile ? '8px' : '8px 16px',
            borderRadius: 12,
            cursor: 'pointer',
            fontSize: 14,
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            gap: 6
          }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
            <polyline points="16 6 12 2 8 6"></polyline>
            <line x1="12" y1="2" x2="12" y2="15"></line>
          </svg>
          {!isMobile && 'Share'}
        </button>
      </div>
      <ShareModal 
        isOpen={showShareModal}
        onClose={() => setShowShareModal(false)}
        url={`${window.location.origin}/course/${course.course_id}`}
      />
    </div>
  );
}

function MiniMap({ lat, lng, name }) {
  const mapContainer = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!mapContainer.current) return;
    let map;
    let marker;
    let isMounted = true;
    (async () => {
      const authHelper = await withIdentityPoolId(identityPoolId);
      map = new maplibregl.Map({
        container: mapContainer.current,
        center: [lng, lat],
        zoom: 6,
        style: `https://maps.geo.${region}.amazonaws.com/maps/v0/maps/${mapName}/style-descriptor`,
        interactive: true,
        attributionControl: false,
        ...authHelper.getMapAuthenticationOptions(),
      });
      mapRef.current = map;
      window._map = map; // Expose map instance for debugging
      map.addControl(new maplibregl.NavigationControl(), "top-left");
      marker = new maplibregl.Marker({ color: "#1D665D" })
        .setLngLat([lng, lat])
        .addTo(map);
    })();
    return () => {
      isMounted = false;
      if (mapRef.current) {
        mapRef.current.remove();
      }
    };
  }, [lat, lng]);

  return (
    <div
      ref={mapContainer}
      style={{ width: "100%", height: 220, borderRadius: 12, boxShadow: "0 2px 10px rgba(0,0,0,0.08)", minWidth: 180 }}
      aria-label={`Mini map for ${name}`}
    />
  );
}

function ConfirmationPopup({ show }) {
  if (!show) return null;
  return (
    <div style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: '#fff',
      borderRadius: 12,
      boxShadow: '0 2px 16px rgba(0,0,0,0.18)',
      padding: '2rem 2.5rem',
      zIndex: 4000,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minWidth: 260
    }}>
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" style={{ marginBottom: 8 }}>
        <circle cx="24" cy="24" r="24" fill="#e4f8ec" />
        <path d="M15 25l6 6 12-14" stroke="#1D665D" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <div style={{ fontSize: 24, fontWeight: 600, color: '#1D665D', marginBottom: 4 }}>Thanks!</div>
      <div style={{ fontSize: 16, color: '#444' }}>Your response was submitted successfully.</div>
    </div>
  );
}

function SubmitMediaModal({ isOpen, onClose, course }) {
  const [mediaLink, setMediaLink] = useState("");
  const [mediaTitle, setMediaTitle] = useState("");
  const [mediaCreator, setMediaCreator] = useState("");
  const [mediaDate, setMediaDate] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userNote, setUserNote] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  if (!isOpen) return null;

  const courseLocation = course.city && course.state ? `${course.city}, ${course.state}` : course.full_address;

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");
    emailjs.send(
      'service_4l5ne0m',
      'template_h3rrjhi',
      {
        course_name: course.name,
        club_name: course.club_name,
        course_id: course.course_id,
        course_location: courseLocation,
        media_link: mediaLink,
        media_title: mediaTitle,
        media_creator: mediaCreator,
        media_date: mediaDate,
        user_email: userEmail,
        user_note: userNote,
      },
      '1BKOUL1Wh5iO6-Dna'
    ).then(
      (result) => {
        setStatus("success");
        setLoading(false);
        setMediaLink("");
        setMediaTitle("");
        setMediaCreator("");
        setMediaDate("");
        setUserEmail("");
        setUserNote("");
        setShowConfirmation(true);
        setTimeout(() => {
          setShowConfirmation(false);
          onClose();
        }, 2000);
      },
      (error) => {
        setStatus("error");
        setLoading(false);
      }
    );
  };

  return (
    <>
      <div className="modal-overlay" style={{
        zIndex: 3000,
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.3)'
      }} onClick={onClose}>
        <div className="modal-content" style={{
          maxWidth: 420,
          width: '100%',
          maxHeight: '90vh',
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 2px 16px rgba(0,0,0,0.18)',
          margin: '40px auto'
        }} onClick={e => e.stopPropagation()}>
          <h2>Submit Media</h2>
          <form onSubmit={handleSubmit} style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 12,
            flex: 1
          }}>
            <label><strong>Course Name:</strong><br /><input type="text" value={course.name} readOnly style={{ width: '100%' }} /></label>
            {/* Hidden field: Course Location is still sent to EmailJS but not shown to the user */}
            <label><strong>Link to Media:</strong><br /><input type="url" value={mediaLink} onChange={e => setMediaLink(e.target.value)} required style={{ width: '100%' }} placeholder="https://..." /></label>
            <label><strong>Title of Media:</strong><br /><input type="text" value={mediaTitle} onChange={e => setMediaTitle(e.target.value)} required style={{ width: '100%' }} /></label>
            <label><strong>Media Creator:</strong><br /><input type="text" value={mediaCreator} onChange={e => setMediaCreator(e.target.value)} required style={{ width: '100%' }} /></label>
            <label><strong>Media Creation Date:</strong><br /><input type="date" value={mediaDate} onChange={e => setMediaDate(e.target.value)} required style={{ width: '100%' }} /></label>
            <label><strong>Your Email (optional):</strong><br /><input type="email" value={userEmail} onChange={e => setUserEmail(e.target.value)} style={{ width: '100%' }} placeholder="you@email.com" /></label>
            <label><strong>Note (optional):</strong><br /><textarea value={userNote} onChange={e => setUserNote(e.target.value)} style={{ width: '100%' }} placeholder="Anything else you'd like to add..." /></label>
            <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
              <button type="submit" className="apply-button" style={{ flex: 1 }} disabled={loading}>{loading ? 'Sending...' : 'Send'}</button>
              <button type="button" className="reset-button" style={{ flex: 1 }} onClick={onClose} disabled={loading}>Cancel</button>
            </div>
            {status === "error" && <div style={{ color: 'red', marginTop: 8 }}>There was an error sending your submission. Please try again.</div>}
          </form>
        </div>
      </div>
      <ConfirmationPopup show={showConfirmation} />
    </>
  );
}

function CourseDetail({ golfCourses, user, playedCourses, playedLoading, onPlayedChange, wishlistCourses, onWishlistChange, courseGuides: initialCourseGuides, onGuidesUpdated: parentGuidesRefresh }) {
  const { id } = useParams();
  const course = golfCourses.find((c) => c.course_id === id);
  const isMobile = window.innerWidth <= 768;
  const [showSubmitMedia, setShowSubmitMedia] = useState(false);
  const [showAdminMedia, setShowAdminMedia] = useState(false);
  const [showAdminGuides, setShowAdminGuides] = useState(false);
  const [mediaList, setMediaList] = useState([]);
  const [localCourseGuides, setLocalCourseGuides] = useState(initialCourseGuides || []);
  const [showShareModal, setShowShareModal] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();
  const mediaSectionRef = useRef(null);
  const overviewSectionRef = useRef(null);

  // Check if user is admin
  useEffect(() => {
    if (user?.uid) {
      checkIsAdmin(user.uid).then(setIsAdmin);
    } else {
      setIsAdmin(false);
    }
  }, [user]);

  // Fetch media - try Firestore first, fall back to JSON
  const fetchMedia = async () => {
    try {
      // Try Firestore first
      const firestoreMedia = await getAllMedia();
      if (firestoreMedia && firestoreMedia.length > 0) {
        setMediaList(firestoreMedia);
        return;
      }
    } catch (error) {
      console.log('Firestore media fetch failed, falling back to JSON:', error);
    }
    // Fallback to JSON
    fetch(`${process.env.PUBLIC_URL}/media.json`)
      .then(res => res.json())
      .then(data => setMediaList(data));
  };

  useEffect(() => {
    fetchMedia();
  }, []);

  // Sync course guides from parent
  useEffect(() => {
    if (initialCourseGuides) {
      setLocalCourseGuides(initialCourseGuides);
    }
  }, [initialCourseGuides]);

  // Fetch course guides (for refreshing after admin edits)
  const fetchCourseGuides = async () => {
    try {
      const firestoreGuides = await getAllCourseGuides();
      if (firestoreGuides && firestoreGuides.length > 0) {
        setLocalCourseGuides(firestoreGuides);
      }
    } catch (error) {
      console.log('Error fetching course guides:', error);
    }
  };

  const courseMedia = course
    ? mediaList.filter(m => m.course_id === course.course_id)
    : [];

  const courseGuidesList = course
    ? localCourseGuides.filter(g => g.course_id === course.course_id)
    : [];

  const scrollToMedia = () => {
    mediaSectionRef.current?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  };

  const scrollToOverview = () => {
    overviewSectionRef.current?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  };

  // Show loading if courses are not loaded yet
  if (!golfCourses || golfCourses.length === 0) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f7f7f7' }}>
        <div style={{ padding: '2rem', background: 'white', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
          <h2>Loading course...</h2>
        </div>
      </div>
    );
  }

  if (!course) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f7f7f7' }}>
        <div style={{ padding: '2rem', background: 'white', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
          <h2>Course Not Found</h2>
          <p>The requested course could not be found.</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f7f7f7', padding: isMobile ? '0.5rem 0' : '2rem 0', width: '100vw', boxSizing: 'border-box', overflowX: 'hidden' }}>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>{`${course.name} at ${course.club_name} - Golf Near Me`}</title>
        <meta name="description" content={`Details, price, and info for ${course.name} at ${course.club_name} in ${course.city}, ${course.state}. Find the best golf courses near you!`} />
      </Helmet>
      <div
        style={{
          maxWidth: isMobile ? '100%' : 1200,
          margin: '0 auto',
          padding: isMobile ? '0 8px' : '0 1rem',
          width: '100%',
          boxSizing: 'border-box',
          overflowX: 'hidden',
        }}
      >
        {/* Back to Map Button */}
        <div style={{ display: 'flex', gap: 12, margin: '18px 0 18px 0', alignItems: 'center' }}>
          <button
            onClick={() => navigate(`/map?course=${course.course_id}`)}
            style={{
              background: '#e0e0e0',
              color: '#333',
              border: 'none',
              padding: '8px 18px',
              borderRadius: 8,
              cursor: 'pointer',
              fontSize: 15,
              fontWeight: 600,
              display: 'inline-block',
            }}
          >
            ← View on Map
          </button>
          <button
            onClick={() => setShowShareModal(true)}
            style={{
              background: '#1D665D',
              color: 'white',
              border: 'none',
              padding: isMobile ? '8px' : '8px 16px',
              borderRadius: 8,
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              gap: 6
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path>
              <polyline points="16 6 12 2 8 6"></polyline>
              <line x1="12" y1="2" x2="12" y2="15"></line>
            </svg>
            {!isMobile && 'Share'}
          </button>
          {/* Add to List Dropdown */}
          {user && !playedLoading && (
            <AddToListDropdown 
              courseId={course.course_id}
              isMobile={isMobile}
              onListsUpdate={(updatedLists) => {
                // This will be handled by the dropdown component itself
              }}
            />
          )}
        </div>
        <div style={{ display: isMobile ? 'block' : 'flex', justifyContent: 'space-between', alignItems: isMobile ? 'flex-start' : 'center', marginBottom: '1.2rem' }}>
          <h1 style={{ fontSize: isMobile ? '1.3rem' : '2rem', fontWeight: 700, margin: 0, color: '#222', wordBreak: 'break-word' }}>
            {course.name} <span style={{ fontWeight: 400, color: '#666', fontSize: isMobile ? '1rem' : '1.2rem' }}>at {course.club_name}</span>
          </h1>
        </div>
        {/* Main Content Layout */}
        <div style={{ display: 'block', width: '100%' }}>
          {/* Content */}
          <div style={{ width: '100%' }}>
            {/* Sleek Navigation Tabs */}
            <div style={{ 
              display: 'flex', 
              gap: 0, 
              marginBottom: '2rem', 
              width: '100%',
              borderBottom: '1px solid #e5e7eb',
              position: 'relative'
            }}>
              <button
                onClick={scrollToOverview}
                style={{
                  padding: '1rem 1.5rem',
                  background: 'transparent',
                  color: '#374151',
                  fontWeight: 600,
                  cursor: 'pointer',
                  fontSize: isMobile ? 14 : 16,
                  outline: 'none',
                  transition: 'all 0.2s ease',
                  border: 'none',
                  borderBottom: '2px solid transparent',
                  position: 'relative',
                  minWidth: 'fit-content'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#1D665D';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = '#374151';
                }}
              >
                Overview
              </button>
              <button
                onClick={() => {
                  const reviewsSection = document.getElementById('reviews-section');
                  reviewsSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }}
                style={{
                  padding: '1rem 1.5rem',
                  background: 'transparent',
                  color: '#374151',
                  fontWeight: 600,
                  cursor: 'pointer',
                  fontSize: isMobile ? 14 : 16,
                  outline: 'none',
                  transition: 'all 0.2s ease',
                  border: 'none',
                  borderBottom: '2px solid transparent',
                  position: 'relative',
                  minWidth: 'fit-content'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#1D665D';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = '#374151';
                }}
              >
                Reviews
              </button>
              <button
                onClick={() => {
                  const locationSection = document.getElementById('location-section');
                  locationSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }}
                style={{
                  padding: '1rem 1.5rem',
                  background: 'transparent',
                  color: '#374151',
                  fontWeight: 600,
                  cursor: 'pointer',
                  fontSize: isMobile ? 14 : 16,
                  outline: 'none',
                  transition: 'all 0.2s ease',
                  border: 'none',
                  borderBottom: '2px solid transparent',
                  position: 'relative',
                  minWidth: 'fit-content'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#1D665D';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = '#374151';
                }}
              >
                Location
              </button>
              <button
                onClick={scrollToMedia}
                style={{
                  padding: '1rem 1.5rem',
                  background: 'transparent',
                  color: '#374151',
                  fontWeight: 600,
                  cursor: 'pointer',
                  fontSize: isMobile ? 14 : 16,
                  outline: 'none',
                  transition: 'all 0.2s ease',
                  border: 'none',
                  borderBottom: '2px solid transparent',
                  position: 'relative',
                  minWidth: 'fit-content'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#1D665D';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = '#374151';
                }}
              >
                Media
              </button>
            </div>
            {/* Page Content */}
            <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', padding: isMobile ? '1.5rem' : '2rem', width: '100%', maxWidth: isMobile ? '100%' : 800, boxSizing: 'border-box', overflowX: 'hidden' }}>
              {/* Key Statistics Section */}
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)', 
                gap: '1.5rem', 
                marginBottom: '2.5rem',
                padding: '1.5rem',
                background: '#f8fafc',
                borderRadius: 12,
                border: '1px solid #e2e8f0'
              }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '2rem', fontWeight: 700, color: '#1D665D', marginBottom: '0.5rem' }}>
                    {course.number_of_holes >= 18 ? 18 : course.number_of_holes}
                  </div>
                  <div style={{ fontSize: '0.875rem', color: '#64748b', fontWeight: 500 }}>Holes</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '2rem', fontWeight: 700, color: '#1D665D', marginBottom: '0.5rem' }}>
                    {course.price === '$Unk' ? 'N/A' : course.price}
                  </div>
                  <div style={{ fontSize: '0.875rem', color: '#64748b', fontWeight: 500 }}>Approx. Price</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '2rem', fontWeight: 700, color: '#1D665D', marginBottom: '0.5rem' }}>
                    {course.type}
                  </div>
                  <div style={{ fontSize: '0.875rem', color: '#64748b', fontWeight: 500 }}>Type</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '2rem', fontWeight: 700, color: '#1D665D', marginBottom: '0.5rem' }}>
                    {course.driving_range === 'Yes' ? 'Yes' : 'No'}
                  </div>
                  <div style={{ fontSize: '0.875rem', color: '#64748b', fontWeight: 500 }}>Driving Range</div>
                </div>
              </div>

              {/* Course Overview Section */}
              <div ref={overviewSectionRef} style={{ marginBottom: '2.5rem' }}>
                <h2 style={{ marginBottom: '1.5rem', color: '#1f2937', wordBreak: 'break-word', fontSize: isMobile ? '1.5rem' : '1.875rem', fontWeight: 700 }}>Course Overview</h2>
                                  <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '1.5rem', width: '100%', maxWidth: '100%', boxSizing: 'border-box', overflowX: 'hidden' }}>
                    <div style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box', overflowX: 'hidden' }}>
                      <h3 style={{ marginBottom: '1rem', color: '#374151', fontSize: isMobile ? '1.125rem' : '1.25rem', fontWeight: 600 }}>Course Details</h3>
                      <div style={{ display: 'grid', gap: '0.75rem', width: '100%', maxWidth: '100%', boxSizing: 'border-box', overflowX: 'hidden' }}>
                      {course.GD100all_rank && course.GD100all_rank !== '' && (
                        <p style={{ margin: 0, fontWeight: 'bold', color: '#1D665D' }}>
                          #{course.GD100all_rank} in America
                        </p>
                      )}
                      {course.GD100pub_rank && course.GD100pub_rank !== '' && (
                        <p style={{ margin: '8px 0 0 0', fontWeight: 'bold', color: '#1D665D' }}>
                          #{course.GD100pub_rank} Public in America
                        </p>
                      )}
                      {course.top100_state_rank && (
                        <>
                          <p style={{ margin: '8px 0 0 0', fontWeight: 'bold' }}>
                            #{course.top100_state_rank} in {course.state}
                          </p>
                          {course.top100_desc && (
                            <p style={{ margin: '0 0 2px 0', fontStyle: 'italic', color: '#444' }}>{fixMojibake(course.top100_desc)}</p>
                          )}
                          <div style={{ fontSize: '11px', color: '#888', marginBottom: '6px' }}>
                            Source of ranking and description: <a href="https://www.top100golfcourses.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#888', textDecoration: 'underline' }}>top100golfcourses.com</a>
                          </div>
                        </>
                      )}
                      {course.notable_architect && course.notable_architect !== 'N' && (
                        <p style={{ margin: '4px 0', color: '#1D665D', fontWeight: '600', fontSize: '13px' }}>
                          <strong>Notable Architect</strong>
                        </p>
                      )}
                      {localCourseGuides && localCourseGuides.some(guide => guide.course_id === course.course_id) && (
                        <p style={{ margin: '4px 0', color: '#1D665D', fontWeight: '600', fontSize: '13px' }}>
                          <strong>Appears in{' '}
                          {localCourseGuides
                            .filter(guide => guide.course_id === course.course_id)
                            .map((guide, index) => (
                              <span key={guide.id || guide.course_id + index}>
                                {index > 0 && ', '}
                                <a
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    const url = guide.link.match(/^https?:\/\//i) ? guide.link : `https://${guide.link}`;
                                    window.open(url, '_blank');
                                  }}
                                  style={{ color: '#1D665D', textDecoration: 'underline', cursor: 'pointer' }}
                                >
                                  {guide.guide}
                                </a>
                              </span>
                            ))}
                          </strong>
                          {isAdmin && (
                            <button
                              onClick={() => setShowAdminGuides(true)}
                              style={{
                                marginLeft: '8px',
                                background: 'none',
                                border: 'none',
                                color: '#7c3aed',
                                cursor: 'pointer',
                                fontSize: '12px',
                                textDecoration: 'underline'
                              }}
                            >
                              Edit
                            </button>
                          )}
                        </p>
                      )}
                      {isAdmin && !localCourseGuides.some(guide => guide.course_id === course.course_id) && (
                        <button
                          onClick={() => setShowAdminGuides(true)}
                          style={{
                            background: '#7c3aed',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 6,
                            padding: '6px 12px',
                            fontSize: '12px',
                            fontWeight: 600,
                            cursor: 'pointer',
                            marginBottom: '8px'
                          }}
                        >
                          + Add to Guide
                        </button>
                      )}
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.75rem', background: '#f8fafc', borderRadius: 8, border: '1px solid #e2e8f0', width: '100%', boxSizing: 'border-box', overflow: 'hidden' }}>
                        <span style={{ fontWeight: 600, color: '#374151', flexShrink: 0 }}>Year Opened</span>
                        <span style={{ color: '#64748b', textAlign: 'right', maxWidth: '60%', overflowWrap: 'break-word', wordBreak: 'normal', flexShrink: 1, minWidth: 0 }}>{course.open_date || 'Information not available'}</span>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.75rem', background: '#f8fafc', borderRadius: 8, border: '1px solid #e2e8f0', width: '100%', boxSizing: 'border-box', overflow: 'hidden' }}>
                        <span style={{ fontWeight: 600, color: '#374151', flexShrink: 0 }}>Architect</span>
                        <span style={{ color: '#64748b', textAlign: 'right', maxWidth: '60%', overflowWrap: 'break-word', wordBreak: 'normal', flexShrink: 1, minWidth: 0 }}>{course.course_architect}</span>
                      </div>

                      {course.website && !isBadLink(course.website) && (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.75rem', background: '#f8fafc', borderRadius: 8, border: '1px solid #e2e8f0', width: '100%', boxSizing: 'border-box', overflow: 'hidden' }}>
                          <span style={{ fontWeight: 600, color: '#374151', flexShrink: 0 }}>Website</span>
                          {(() => {
                            const url = course.website.match(/^https?:\/\//i)
                              ? course.website
                              : `https://${course.website}`;
                            return (
                              <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: '#1D665D', textDecoration: 'underline', overflowWrap: 'break-word', wordBreak: 'normal', textAlign: 'right', maxWidth: '60%' }}>
                                {course.website}
                              </a>
                            );
                          })()}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Reviews Section */}
              <div id="reviews-section" style={{ marginBottom: '2.5rem' }}>
                <CourseReviews courseId={course.course_id} courseName={course.name} />
              </div>

              {/* Location Section */}
              <div id="location-section" style={{ marginBottom: '2.5rem' }}>
                <h2 style={{ marginBottom: '1.5rem', color: '#1f2937', wordBreak: 'break-word', fontSize: isMobile ? '1.5rem' : '1.875rem', fontWeight: 700 }}>Location</h2>
                
                {/* Map Card */}
                <div style={{ 
                  marginBottom: '1.5rem',
                  background: '#fff',
                  borderRadius: 16,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                  border: '1px solid #e2e8f0',
                  overflow: 'hidden'
                }}>
                  <MiniMap lat={course.lat} lng={course.lng} name={course.name} />
                </div>

                {/* Address Card */}
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center', 
                  padding: '0.75rem', 
                  background: '#f8fafc', 
                  borderRadius: 8, 
                  border: '1px solid #e2e8f0'
                }}>
                  <span style={{ fontWeight: 600, color: '#374151' }}>Address</span>
                  <a 
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(course.full_address)}`} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                                          style={{ 
                        color: '#1D665D', 
                        textDecoration: 'underline', 
                        overflowWrap: 'break-word', 
                        wordBreak: 'normal', 
                        textAlign: 'right', 
                        maxWidth: '60%'
                      }}
                  >
                    {course.full_address}
                  </a>
                </div>
              </div>

              {/* Media Section */}
              <div ref={mediaSectionRef} style={{ marginTop: '2rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', flexWrap: 'wrap', gap: '0.5rem' }}>
                  <h2 style={{ margin: 0, color: '#1f2937', wordBreak: 'break-word', fontSize: isMobile ? '1.5rem' : '1.875rem', fontWeight: 700 }}>Media</h2>
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    {isAdmin && (
                      <button
                        onClick={() => setShowAdminMedia(true)}
                        style={{
                          background: '#7c3aed',
                          color: '#fff',
                          border: 'none',
                          borderRadius: 8,
                          padding: '0.75rem 1.5rem',
                          fontWeight: 600,
                          fontSize: '0.875rem',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease',
                          boxShadow: '0 2px 4px rgba(124, 58, 237, 0.2)'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.background = '#6d28d9';
                          e.target.style.transform = 'translateY(-1px)';
                          e.target.style.boxShadow = '0 4px 8px rgba(124, 58, 237, 0.3)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.background = '#7c3aed';
                          e.target.style.transform = 'translateY(0)';
                          e.target.style.boxShadow = '0 2px 4px rgba(124, 58, 237, 0.2)';
                        }}
                      >
                        Manage Media
                      </button>
                    )}
                    <button
                      onClick={() => setShowSubmitMedia(true)}
                      style={{
                        background: '#1D665D',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 8,
                        padding: '0.75rem 1.5rem',
                        fontWeight: 600,
                        fontSize: '0.875rem',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 2px 4px rgba(29, 102, 93, 0.2)'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.background = '#1a5a52';
                        e.target.style.transform = 'translateY(-1px)';
                        e.target.style.boxShadow = '0 4px 8px rgba(29, 102, 93, 0.3)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = '#1D665D';
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 2px 4px rgba(29, 102, 93, 0.2)';
                      }}
                    >
                      Submit Media
                    </button>
                  </div>
                </div>
                <SubmitMediaModal isOpen={showSubmitMedia} onClose={() => setShowSubmitMedia(false)} course={course} />
                <AdminMediaModal
                  isOpen={showAdminMedia}
                  onClose={() => setShowAdminMedia(false)}
                  course={course}
                  existingMedia={courseMedia}
                  onMediaUpdated={fetchMedia}
                />
                <AdminCourseGuidesModal
                  isOpen={showAdminGuides}
                  onClose={() => setShowAdminGuides(false)}
                  course={course}
                  existingGuides={courseGuidesList}
                  onGuidesUpdated={async () => {
                    // Await both refreshes to ensure state is updated before user navigates away
                    await Promise.all([
                      fetchCourseGuides(),
                      parentGuidesRefresh ? parentGuidesRefresh() : Promise.resolve()
                    ]);
                  }}
                />
                <div style={{ display: 'grid', gap: '1.5rem', width: '100%' }}>
                  {courseMedia.length > 0 ? (
                    courseMedia.map((media, idx) => (
                      <div key={idx} style={{ 
                        width: '100%', 
                        maxWidth: isMobile ? '100%' : 700, 
                        margin: '0 auto', 
                        background: '#fff', 
                        borderRadius: 12, 
                        padding: '1.5rem', 
                        boxShadow: '0 4px 20px rgba(0,0,0,0.08)', 
                        border: '1px solid #e2e8f0',
                        boxSizing: 'border-box', 
                        overflowX: 'auto',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 8px 30px rgba(0,0,0,0.12)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 4px 20px rgba(0,0,0,0.08)';
                      }}
                      >
                        {/* Responsive media embed */}
                        {media.media_link ? (
                          media.media_link.includes('youtube.com') || media.media_link.includes('youtu.be') ? (
                            <div style={{ position: 'relative', width: '100%', paddingBottom: '56.25%', height: 0 }}>
                              <iframe
                                style={{ position: 'absolute', top: 0, left: '0', width: '100%', height: '100%', borderRadius: 6 }}
                                src={media.media_link.replace('watch?v=', 'embed/')}
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                              ></iframe>
                            </div>
                          ) : media.media_link.includes('instagram.com') ? (
                            <div style={{ width: '100%', maxWidth: '100vw' }}>
                              <InstagramEmbedSimple url={media.media_link} maxWidth={isMobile ? '100vw' : 480} />
                            </div>
                          ) : media.media_link.includes('x.com') || media.media_link.includes('twitter.com') ? (
                            <div style={{ width: '100%', maxWidth: '100vw' }}>
                              <XEmbedSimple url={media.media_link} maxWidth={isMobile ? '100vw' : 480} />
                            </div>
                          ) : (
                            <a href={media.media_link} target="_blank" rel="noopener noreferrer">View Media</a>
                          )
                        ) : (
                          <span style={{ color: '#888' }}>No media link provided.</span>
                        )}
                      </div>
                    ))
                                      ) : (
                      <div style={{ 
                        textAlign: 'center', 
                        padding: '3rem 2rem',
                        background: '#f8fafc',
                        borderRadius: 12,
                        border: '2px dashed #cbd5e1'
                      }}>
                        <p style={{ color: '#64748b', fontStyle: 'italic', fontSize: '1rem', margin: 0 }}>
                          No media content available for this course yet.
                        </p>
                        <p style={{ color: '#94a3b8', fontSize: '0.875rem', margin: '0.5rem 0 0 0' }}>
                          Be the first to share photos or videos!
                        </p>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>

        </div>
        {/* Add the ShareModal */}
        <ShareModal 
          isOpen={showShareModal}
          onClose={() => setShowShareModal(false)}
          url={`${window.location.origin}/course/${course.course_id}`}
        />
      </div>
    </div>
  );
}

function ContactModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <h2>Contact Information</h2>
        <div className="contact-info">
          <p><strong>Email:</strong> <a href="mailto:matt@golfnear.me">matt@golfnear.me</a></p>
        </div>
        <button onClick={onClose} className="close-button">Close</button>
      </div>
    </div>
  );
}

// ClusterHoverCard component removed - simplifying to just use tooltips like the specialized map

function AppRoutes({ user, setUser }) {
  const [playedCourses, setPlayedCourses] = useState([]);
  const [wishlistCourses, setWishlistCourses] = useState([]);
  const [playedLoading, setPlayedLoading] = useState(true);
  
  // Add list filtering state
  const [listCourseIds, setListCourseIds] = useState([]);
  const [listName, setListName] = useState('');

  // Move allTypes to the very top so it can be used in useState below
  const allTypes = [
    "Public",
    "Municipal",
    "Semi-Private",
    "Resort",
    "University",
    "Military",
    "Private",
    "18 Holes"
  ];

  // clusterHoverInfo state removed - simplifying to just use tooltips like the specialized map

  const { articleId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const isMapPage = location.pathname.startsWith('/map');
  const justClickedRef = useRef(false);
  const [isSuggestionClicked, setIsSuggestionClicked] = useState(false);

  // Map state
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const markersRef = useRef({});
  const centerDotRef = useRef(null);
  const [golfCourses, setGolfCourses] = useState([]);
  const [visibleCourses, setVisibleCourses] = useState([]);
  const [hoveredCourse, setHoveredCourse] = useState(null);
  // hoveredCluster state removed - simplifying to just use hoveredCourse like the specialized map
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [hasMediaOnly, setHasMediaOnly] = useState(false);
  const [selectedMediaTypes, setSelectedMediaTypes] = useState([]);
  const [mediaDropdownOpen, setMediaDropdownOpen] = useState(false);
  const [top100AllOnly, setTop100AllOnly] = useState(false);
  const [top100PublicOnly, setTop100PublicOnly] = useState(false);
  const minPriceRef = useRef(null);
  const maxPriceRef = useRef(null);
  const selectedTypesRef = useRef([]);
  const sortOrderRef = useRef("desc");
  const rankedOnlyRef = useRef(false);
  const hasMediaOnlyRef = useRef(false);
  const selectedMediaTypesRef = useRef([]); // <-- Added missing ref
  const top100AllOnlyRef = useRef(false);
  const top100PublicOnlyRef = useRef(false);
  const [minPrice, setMinPrice] = useState(null);
  const [maxPrice, setMaxPrice] = useState(null);
  const [selectedTypes, setSelectedTypes] = useState(allTypes.filter(type => type !== "18 Holes"));
  const [tempMinPrice, setTempMinPrice] = useState(null);
  const [tempMaxPrice, setTempMaxPrice] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [moreDropdownOpen, setMoreDropdownOpen] = useState(false);
  const [sortOrder, setSortOrder] = useState("distance");
  const [rankedOnly, setRankedOnly] = useState(false);
  const [recommendedRankedOnly, setRecommendedRankedOnly] = useState(false);
  const [recommendedNotableArchitects, setRecommendedNotableArchitects] = useState(false);
  const [recommendedAppearsInGuide, setRecommendedAppearsInGuide] = useState(false);
  const [recommendedAnyRecommended, setRecommendedAnyRecommended] = useState(false);
  const [courseGuides, setCourseGuides] = useState([]);
  const [recommendedDropdownOpen, setRecommendedDropdownOpen] = useState(false);
  const [recommendedDropdownOpenMobile, setRecommendedDropdownOpenMobile] = useState(false);
  const [architectOptions, setArchitectOptions] = useState([]);
  const [selectedArchitects, setSelectedArchitects] = useState([]);
  useEffect(() => {
    if (selectedTypes.length === 0) {
      setSelectedTypes(allTypes.filter(type => type !== "18 Holes"));
    }
  }, []);
  const [architectDropdownOpen, setArchitectDropdownOpen] = useState(false);
  const selectedArchitectsRef = useRef([]);
  const [architectSearch, setArchitectSearch] = useState("");
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [mediaList, setMediaList] = useState([]);

  const [tooltipInfo, setTooltipInfo] = useState(null); // Will hold { course, position, sticky }
  const tooltipTimeoutRef = useRef(null);
  const [pendingCoordinates, setPendingCoordinates] = useState(null);
  const [currentLocationMarker, setCurrentLocationMarker] = useState(null);
  const [mapLoaded, setMapLoaded] = useState(false); // <-- Move this here
  const pendingCoordinatesRef = useRef(null);
  const [showSignInPrompt, setShowSignInPrompt] = useState(false);
  const lastFlownToCourseId = useRef(null);


  // Add a ref to track if the user has manually typed in the search bar
  const hasUserTyped = useRef(false);
  // Add a ref to track if we've already handled the search param to prevent duplicate calls
  const hasHandledSearchParam = useRef(false);

  // User authentication effect
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      setUser(firebaseUser);
      if (firebaseUser) {
        const userRef = doc(db, "users", firebaseUser.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          setPlayedCourses(userSnap.data().playedCourses || []);
          setWishlistCourses(userSnap.data().wishlistCourses || []);
        } else {
          setPlayedCourses([]);
          setWishlistCourses([]);
        }
      } else {
        setPlayedCourses([]);
        setWishlistCourses([]);
      }
      setPlayedLoading(false);
    });
    return () => unsubscribe();
  }, []);

  // --- Main search bar city/state and course autocomplete ---
  const [showCityDropdown, setShowCityDropdown] = useState(false);
  // Build unique city/state pairs with course count
  const cityStateCounts = React.useMemo(() => {
    const map = new Map();
    golfCourses.forEach(c => {
      if (c.city && c.state) {
        const key = `${c.city}, ${c.state}`;
        map.set(key, (map.get(key) || 0) + 1);
      }
    });
    return Array.from(map.entries()).map(([cityState, count]) => ({ cityState, count }));
  }, [golfCourses]);

  // Combined search results with cities prioritized and ranked by popularity
  const filteredResults = React.useMemo(() => {
    if (!searchTerm.length) return [];

    const results = [];
    const searchTermLower = searchTerm.toLowerCase();
    
    // Normalize search term for Saint/St variations
    const normalizeText = (text) => {
      return text
        .replace(/\bsaint\b/gi, 'st')
        .replace(/\bst\./gi, 'st')
        .replace(/\bst\b/gi, 'saint');
    };
    
    const normalizedSearchTerm = normalizeText(searchTermLower);
    
    // First, add city/state matches with smart ranking
    const cityMatches = cityStateCounts
      .filter(({ cityState }) => {
        const normalizedCityState = normalizeText(cityState.toLowerCase());
        return normalizedCityState.includes(searchTermLower) || 
               normalizedCityState.includes(normalizedSearchTerm) ||
               cityState.toLowerCase().includes(searchTermLower);
      })
      .map(({ cityState, count }) => {
        // Calculate a score for ranking
        let score = count * 10; // Base score from course count
        
        // Bonus for exact city name match (e.g., "Dallas" matches "Dallas, Texas")
        const cityName = cityState.split(',')[0].toLowerCase();
        const normalizedCityName = normalizeText(cityName);
        
        if (cityName === searchTermLower || normalizedCityName === searchTermLower || normalizedCityName === normalizedSearchTerm) {
          score += 1000; // Big bonus for exact city name match
        }
        
        // Bonus for starting with search term
        if (cityName.startsWith(searchTermLower) || normalizedCityName.startsWith(searchTermLower) || normalizedCityName.startsWith(normalizedSearchTerm)) {
          score += 500;
        }
        
        // Bonus for containing search term (partial matches)
        if (cityName.includes(searchTermLower) || normalizedCityName.includes(searchTermLower) || normalizedCityName.includes(normalizedSearchTerm)) {
          score += 200;
        }
        
        // Bonus for state abbreviation match (e.g., "TX" in search)
        const stateName = cityState.split(',')[1]?.trim().toLowerCase();
        if (stateName && stateName.startsWith(searchTermLower)) {
          score += 300;
        }
        
        // Bonus for state abbreviation match (e.g., "Texas" matches "TX")
        const stateAbbreviations = {
          'alabama': 'al', 'alaska': 'ak', 'arizona': 'az', 'arkansas': 'ar', 'california': 'ca',
          'colorado': 'co', 'connecticut': 'ct', 'delaware': 'de', 'florida': 'fl', 'georgia': 'ga',
          'hawaii': 'hi', 'idaho': 'id', 'illinois': 'il', 'indiana': 'in', 'iowa': 'ia',
          'kansas': 'ks', 'kentucky': 'ky', 'louisiana': 'la', 'maine': 'me', 'maryland': 'md',
          'massachusetts': 'ma', 'michigan': 'mi', 'minnesota': 'mn', 'mississippi': 'ms', 'missouri': 'mo',
          'montana': 'mt', 'nebraska': 'ne', 'nevada': 'nv', 'new hampshire': 'nh', 'new jersey': 'nj',
          'new mexico': 'nm', 'new york': 'ny', 'north carolina': 'nc', 'north dakota': 'nd', 'ohio': 'oh',
          'oklahoma': 'ok', 'oregon': 'or', 'pennsylvania': 'pa', 'rhode island': 'ri', 'south carolina': 'sc',
          'south dakota': 'sd', 'tennessee': 'tn', 'texas': 'tx', 'utah': 'ut', 'vermont': 'vt',
          'virginia': 'va', 'washington': 'wa', 'west virginia': 'wv', 'wisconsin': 'wi', 'wyoming': 'wy'
        };
        
        if (stateName && stateAbbreviations[stateName] === searchTermLower) {
          score += 400; // Even bigger bonus for exact state abbreviation match
        }
        
        return { cityState, count, score };
      })
      .sort((a, b) => b.score - a.score) // Sort by score descending
      .slice(0, 8); // Limit city results to leave room for courses
    
    cityMatches.forEach(({ cityState, count }) => {
      results.push({
        type: 'city',
        cityState,
        count,
        label: cityState
      });
    });
    
    // Then add course matches
    const courseMatches = golfCourses.filter(course =>
      course.name.toLowerCase().includes(searchTermLower) ||
      course.club_name.toLowerCase().includes(searchTermLower)
    ).slice(0, 6); // Limit course results
    
    courseMatches.forEach(course => {
      results.push({
        type: 'course',
        courseId: course.course_id,
        name: course.name,
        clubName: course.club_name,
        city: course.city,
        state: course.state,
        lat: course.lat,
        lng: course.lng
      });
    });
    
    return results;
  }, [searchTerm, cityStateCounts, golfCourses]);

  // Handle search result selection
  const handleSelectResult = (result) => {
    if (result.type === 'city') {
      setIsSuggestionClicked(true);
      setSearchTerm(result.cityState);
      setShowCityDropdown(false);
      handleSearch(result.cityState);
    } else if (result.type === 'course') {
      setIsSuggestionClicked(true);
      setSearchTerm(result.name);
      setShowCityDropdown(false);
      // Fly to the course location on the map
      if (mapInstance.current && result.lat && result.lng) {
        const flyToOptions = {
          center: [result.lng, result.lat],
          zoom: 15,
          essential: true,
        };
        if (!isMobile) {
          flyToOptions.offset = [300, 0];
        }
        mapInstance.current.flyTo(flyToOptions);
        
        // Find and select the course
        const course = golfCourses.find(c => c.course_id === result.courseId);
        if (course) {
          setSelectedCourse(course);
          setTooltipInfo(null);
        }
      }
    }
  };


  useEffect(() => {
    minPriceRef.current = minPrice;
    maxPriceRef.current = maxPrice;
    selectedTypesRef.current = selectedTypes;
    sortOrderRef.current = sortOrder;
    selectedArchitectsRef.current = selectedArchitects;
    rankedOnlyRef.current = rankedOnly;
    hasMediaOnlyRef.current = hasMediaOnly;
    selectedMediaTypesRef.current = selectedMediaTypes;
  }, [minPrice, maxPrice, selectedTypes, sortOrder, selectedArchitects, rankedOnly, hasMediaOnly, selectedMediaTypes]);

  const handleSearch = async (searchQuery) => {
    const query = (typeof searchQuery === 'string') ? searchQuery : searchTerm;
    if (!query || !query.trim()) return;
  
    if (!mapInstance.current) {
      setTimeout(() => handleSearch(query), 100);
      return;
    }
  
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}`
      );
      const results = await response.json();
      if (results.length > 0 && mapInstance.current) {
        const { lat, lon } = results[0];
        const map = mapInstance.current;

        const flyToOptions = {
          center: [parseFloat(lon), parseFloat(lat)],
          zoom: 10,
          essential: true,
        };

        if (!isMobile) {
          // Check if this search came from a URL parameter (home page search)
          const urlSearch = searchParams.get('search');
          const isFromHomePage = urlSearch && urlSearch === query;
          
          // Use larger offset for home page search (sidebar is visible)
          // Use smaller offset for in-map search (sidebar might be collapsed or different)
          flyToOptions.offset = isFromHomePage ? [300, 0] : [300, 0];
        }
        
        map.flyTo(flyToOptions);
        
        // Add a listener for when flyTo completes
        let flyToCompleted = false;
        const onFlyToComplete = () => {
          if (!flyToCompleted) {
            flyToCompleted = true;
            // Force a cluster update after flyTo completes
            setTimeout(() => {
              if (typeof updateClusters === 'function') {
                updateClusters();
              }
            }, 100);
            // Remove this specific listener without affecting others
            map.off('moveend', onFlyToComplete);
          }
        };
        
        // Listen for moveend and trigger our custom event when flyTo completes
        const moveEndHandler = () => {
          if (!flyToCompleted) {
            // Check if we're close to the target coordinates
            const center = map.getCenter();
            const targetLng = parseFloat(lon);
            const targetLat = parseFloat(lat);
            const distance = Math.sqrt(
              Math.pow(center.lng - targetLng, 2) + 
              Math.pow(center.lat - targetLat, 2)
            );
            
            if (distance < 0.01) { // Within ~1km of target
              flyToCompleted = true;
              map.off('moveend', moveEndHandler);
              onFlyToComplete();
            }
          }
        };
        
        map.on('moveend', moveEndHandler);
      }
    } catch (error) {
      console.error('Error searching for location:', error);
    }
  };

  // Helper to add current location pulsing marker after style is loaded
  function removeCurrentLocationLayer(map) {
    // Remove previous animation if any
    if (window._currentLocationAnimationId) {
      cancelAnimationFrame(window._currentLocationAnimationId);
      window._currentLocationAnimationId = null;
    }

    // Remove layers and source
    const layersToRemove = ['current-location-dot', 'current-location-green', 'current-location-white'];
    layersToRemove.forEach(layerId => {
      try {
        if (map.getLayer && map.getLayer(layerId)) map.removeLayer(layerId);
      } catch (e) {
        console.warn('Layer removal error:', layerId, e);
      }
    });
    try {
      if (map.getSource && map.getSource('current-location')) {
        map.removeSource('current-location');
      }
    } catch (e) {
      console.warn('Source removal error:', e);
    }
  }

  function addCurrentLocationLayer(map, lng, lat) {
    // Always check style loaded before proceeding
    if (!map.isStyleLoaded()) {
      map.once('style.load', () => addCurrentLocationLayer(map, lng, lat));
      return;
    }

    // Remove previous layers first
    removeCurrentLocationLayer(map);

    // Only add the source if it doesn't already exist
    if (!map.getSource('current-location')) {
      map.addSource('current-location', {
        type: 'geojson',
        data: {
          type: 'Feature',
          geometry: { type: 'Point', coordinates: [lng, lat] },
          properties: { pulse: 0 }
        }
      });
    }

    // White background circle (fixed size)
    map.addLayer({
      id: 'current-location-white',
      type: 'circle',
      source: 'current-location',
      paint: {
        'circle-radius': [
          'interpolate', ['linear'], ['zoom'],
          10, 12,
          15, 16
        ],
        'circle-color': '#fff',
        'circle-opacity': 0.7
      }
    });

    // Green pulsing circle (on top)
    map.addLayer({
      id: 'current-location-green',
      type: 'circle',
      source: 'current-location',
      paint: {
        'circle-radius': [
          'interpolate', ['linear'], ['zoom'],
          10, [
            'interpolate', ['linear'], ['get', 'pulse'],
            0, 6,
            1, 12
          ],
          15, [
            'interpolate', ['linear'], ['get', 'pulse'],
            0, 8,
            1, 16
          ]
        ],
        'circle-color': '#1D665D',
        'circle-opacity': 0.9
      }
    }, 'current-location-white'); // Add above white

    // Add a solid dark green dot in the center (on top)
    map.addLayer({
      id: 'current-location-dot',
      type: 'circle',
      source: 'current-location',
      paint: {
        'circle-radius': [
          'interpolate', ['linear'], ['zoom'],
          10, 7,
          15, 10
        ],
        'circle-color': '#1D665D',
        'circle-opacity': 1
      }
    }); // Add last, so it's on top

    // Animation code
    let pulseValue = 0;
    let pulseDirection = 1;
    const pulseSpeed = 0.02;
    const pulseAnimation = () => {
      pulseValue += pulseSpeed * pulseDirection;
      if (pulseValue >= 1) { pulseValue = 1; pulseDirection = -1; }
      else if (pulseValue <= 0) { pulseValue = 0; pulseDirection = 1; }
      // SAFETY CHECKS
      if (!map || !map.getSource || !map.getSource('current-location')) {
        window._currentLocationAnimationId = null;
        return;
      }
      map.getSource('current-location').setData({
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [lng, lat] },
        properties: { pulse: pulseValue }
      });
      window._currentLocationAnimationId = requestAnimationFrame(pulseAnimation);
    };
    pulseAnimation();
  }

  const handleCurrentLocation = () => {
    if (!navigator.geolocation) {
      alert('Geolocation is not supported by this browser.');
      return;
    }
    if (!mapInstance.current || !mapLoaded) {
      setTimeout(() => handleCurrentLocation(), 100);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        if (mapInstance.current) {
          addCurrentLocationLayer(mapInstance.current, longitude, latitude);
          const flyToOptions = {
            center: [longitude, latitude],
            zoom: 10,
            essential: true
          };
          if (!isMobile) {
            flyToOptions.offset = [300, 0];
          }
          mapInstance.current.flyTo(flyToOptions);
          setSearchTerm('Current Location');
          setTooltipInfo(null);
          // Clear any marker highlighting when clearing selected course
          if (selectedCourse && markersRef.current[selectedCourse.course_id]) {
            const el = markersRef.current[selectedCourse.course_id].element;
            const photoUrl = selectedCourse.photo_url;
            forceResetMarkerHighlight(el, selectedCourse.course_id, photoUrl);
          }
          setSelectedCourse(null);
        }
      }
    );
  };

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/courses.json`)
      .then((res) => res.json())
      .then((data) => {
        setGolfCourses(data);
        setMinPrice(null);
        setMaxPrice(null);
        setTempMinPrice(null);
        setTempMaxPrice(null);
        // Extract unique architects
        const uniqueArchitects = Array.from(new Set(data.map(c => c.course_architect).filter(a => a && a !== 'N/D'))).sort();
        setArchitectOptions(uniqueArchitects);
      });
  }, []);

  useEffect(() => {
    if (!isMapPage) return;
    
    if (mapInstance.current) {
      return;
    }
    
    if (!mapRef.current) {
      return;
    }
    const initMap = async () => {
      const authHelper = await withIdentityPoolId(identityPoolId);
      const initialZoom = isMobile ? 1.9 : 3.5;
      const initialCenter = isMobile ? [-98.5795, 39.8283] : [-118.5795, 39.8283];
      const map = new maplibregl.Map({
        container: mapRef.current,
        center: initialCenter,
        zoom: initialZoom,
        style: `https://maps.geo.${region}.amazonaws.com/maps/v0/maps/${mapName}/style-descriptor`,
        ...authHelper.getMapAuthenticationOptions(),
      });

      mapInstance.current = map;
      window._map = map; // Expose map instance for debugging
      map.addControl(new maplibregl.NavigationControl(), "top-left");

      map.on("load", () => {
        if (!isMobile) {
          map.setPadding({ right: 650 });
        }
        setMapLoaded(true);
        updateClusters();
        // Handle pending coordinates after map is ready
        if (pendingCoordinatesRef.current) {
          const { lat, lng, isCurrentLocation } = pendingCoordinatesRef.current;
          
          // Only add current location marker if it's actually a current location request
          if (isCurrentLocation) {
            addCurrentLocationLayer(map, lng, lat);
            setSearchTerm('Current Location');
          }
          
          const flyToOptions = {
            center: [lng, lat],
            zoom: isCurrentLocation ? 10 : 15,
            essential: true
          };
          if (!isMobile) {
            flyToOptions.offset = [300, 0];
          }
          map.flyTo(flyToOptions); // Use flyTo for smooth animation
          setPendingCoordinates(null);
          pendingCoordinatesRef.current = null;
        }
      });
    };

    // Small delay to ensure DOM is ready
    setTimeout(() => {
      if (mapRef.current) {
    initMap();
      }
    }, 100);

    // Robust cleanup for current location marker and animation
    return () => {
      if (window._currentLocationAnimationId) {
        cancelAnimationFrame(window._currentLocationAnimationId);
        window._currentLocationAnimationId = null;
      }
      if (mapInstance.current) {
        if (mapInstance.current.getLayer && mapInstance.current.getLayer('current-location-green')) mapInstance.current.removeLayer('current-location-green');
        if (mapInstance.current.getLayer && mapInstance.current.getLayer('current-location-white')) mapInstance.current.removeLayer('current-location-white');
        if (mapInstance.current.getSource && mapInstance.current.getSource('current-location')) mapInstance.current.removeSource('current-location');
        mapInstance.current.remove(); // fully destroy the map instance
        mapInstance.current = null;  // clear the ref so it can be re-initialized
      }
    };
  }, [isMapPage]);

  // Update the function signature
  const updateVisibleCourses = (map, currentMin, currentMax, selectedTypes, currentSortOrder = sortOrder, currentArchitects = selectedArchitects, currentRankedOnly = rankedOnly, currentHasMediaOnly = hasMediaOnly, currentMediaTypes = selectedMediaTypes, selectedCourseParam = selectedCourse, listCourseIds = []) => {
    const bounds = map.getBounds();
    const container = map.getContainer();
    const width = container.clientWidth;
    const height = container.clientHeight;
    const rightPadding = 650;
    const visualCenterX = (width - rightPadding) / 2 + rightPadding;
    const nudgeX = 200;
    const nudgeY = 30;
    const visualCenter = map.unproject([
      visualCenterX - nudgeX,
      (height / 2) - nudgeY
    ]);
    
    // Get the actual map center for distance calculations
    const mapCenter = map.getCenter();
    const center = { lat: mapCenter.lat, lng: mapCenter.lng };

    // Step 1: Filter all courses in bounds and matching filters
    const filtered = golfCourses.filter((course) => {
      const priceValue = parseInt(course.price.replace(/\D/g, ""));
      const matchesBounds =
        course.lat >= bounds.getSouth() &&
        course.lat <= bounds.getNorth() &&
        course.lng >= bounds.getWest() &&
        course.lng <= bounds.getEast();
      const matchesPrice =
        (currentMin === null || priceValue >= currentMin) &&
        (currentMax === null || priceValue <= currentMax);
      const matchesType = selectedTypes.length > 0 && selectedTypes.some(type => 
        type.toLowerCase() === (course.type || '').toLowerCase()
      );
      const matchesEighteen = !selectedTypes.includes("18 Holes") || course.number_of_holes >= 18;
      const matchesArchitect = currentArchitects.length === 0 || currentArchitects.includes(course.course_architect);
      const matchesRanked = recommendedRankedOnly ? (course.top100_state_rank && course.top100_state_rank !== '') : (!currentRankedOnly || (course.top100_state_rank && course.top100_state_rank !== ''));
      const matchesMedia = !currentHasMediaOnly || courseHasMedia(course, mediaList);
      const matchesMediaTypes = currentMediaTypes.length === 0 || currentMediaTypes.some(type => 
        mediaList.some(m => m.course_id === course.course_id && m.media_type === type)
      );
      const matchesSearch = true; // Course search removed - always match
      const matchesNotableArchitects = !recommendedNotableArchitects || (course.notable_architect && course.notable_architect !== 'N');
      const matchesAppearsInGuide = !recommendedAppearsInGuide || courseGuides.some(guide => guide.course_id === course.course_id);
      const matchesAnyRecommended = !recommendedAnyRecommended || (
        (course.top100_state_rank && course.top100_state_rank !== '') ||
        (course.notable_architect && course.notable_architect !== 'N') ||
        courseGuides.some(guide => guide.course_id === course.course_id)
      );
      // List filter - if listCourseIds is provided, only show those courses
      const matchesList = listCourseIds.length === 0 || listCourseIds.includes(course.course_id);
      
      if ((currentSortOrder === 'asc' || currentSortOrder === 'desc')) {
        if (!priceValue) return false;
      }
      return matchesBounds && matchesPrice && matchesType && matchesEighteen && matchesArchitect && matchesRanked && matchesMedia && matchesMediaTypes && matchesSearch && matchesNotableArchitects && matchesAppearsInGuide && matchesAnyRecommended && matchesList;
    });

    // Step 2: Split into priority groups based on rankings
    const group1 = [], group2 = [];
    filtered.forEach(course => {
      const hasNationalRank = !!(course.GD100all_rank && course.GD100all_rank !== '');
      const hasPublicRank = !!(course.GD100pub_rank && course.GD100pub_rank !== '');
      const hasStateRank = !!(course.top100_state_rank && course.top100_state_rank !== '');
      const isRanked = hasNationalRank || hasPublicRank || hasStateRank;
      if (isRanked) {
        group1.push(course);
      } else {
        group2.push(course);
      }
    });
    
    // Sort ranked courses by priority: Public > National > State > Price
    group1.sort((a, b) => {
      // First priority: GD100pub_rank (Public ranking)
      const aPublicRank = parseInt(a.GD100pub_rank) || 999;
      const bPublicRank = parseInt(b.GD100pub_rank) || 999;
      if (aPublicRank !== bPublicRank) return aPublicRank - bPublicRank;
      
      // Second priority: GD100all_rank (National ranking)
      const aNationalRank = parseInt(a.GD100all_rank) || 999;
      const bNationalRank = parseInt(b.GD100all_rank) || 999;
      if (aNationalRank !== bNationalRank) return aNationalRank - bNationalRank;
      
      // Third priority: top100_state_rank (State ranking)
      const aStateRank = parseInt(a.top100_state_rank) || 999;
      const bStateRank = parseInt(b.top100_state_rank) || 999;
      if (aStateRank !== bStateRank) return aStateRank - bStateRank;
      
      // Fourth priority: Price (higher price first)
      const aPrice = (a.price && parseInt(a.price.replace(/\D/g, ""))) || 0;
      const bPrice = (b.price && parseInt(b.price.replace(/\D/g, ""))) || 0;
      return bPrice - aPrice;
    });
    
    // Sort unranked courses by distance from map center
    group2.sort((a, b) => {
      const distA = Math.sqrt(Math.pow(a.lat - center.lat, 2) + Math.pow(a.lng - center.lng, 2));
      const distB = Math.sqrt(Math.pow(b.lat - center.lat, 2) + Math.pow(b.lng - center.lng, 2));
        return distA - distB;
    });
    
    const pinLimit = 500;
    const visible = [];
    for (const course of group1) { if (visible.length < pinLimit) visible.push(course); else break; }
    for (const course of group2) { if (visible.length < pinLimit) visible.push(course); else break; }
    if (visible.length < pinLimit)
    return visible.length < pinLimit ? visible : visible.slice(0, pinLimit);
  }

  // Add a separate effect to handle selected course cleanup
  useEffect(() => {
    if (!selectedCourse && markersRef.current) {
      // Remove selected class from all markers when no course is selected
      Object.values(markersRef.current).forEach(({ element }) => {
        if (element) {
          element.classList.remove("selected");
        }
      });
    }
  }, [selectedCourse]);

  // Add this function to handle mobile menu toggle
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Add this function to handle closing mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".filter-group") && !e.target.closest(".mobile-menu-button")) {
        setDropdownOpen(false);
        setMoreDropdownOpen(false);
        setArchitectDropdownOpen(false);
        setArchitectSearch("");
        setIsMobileMenuOpen(false);
        setMediaDropdownOpen(false);
        setRecommendedDropdownOpen(false);
        setRecommendedDropdownOpenMobile(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleTypeChange = (type, checked) => {
    if (!user) {
      setShowSignInPrompt(true);
      return;
    }
    setSelectedTypes(prev => {
      const newTypes = checked
        ? [...prev, type]
        : prev.filter(t => t !== type);
      return newTypes;
    });
  };

  // Responsive screen size effect
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Try Firestore first, fall back to JSON
    const loadMedia = async () => {
      try {
        const firestoreMedia = await getAllMedia();
        if (firestoreMedia && firestoreMedia.length > 0) {
          setMediaList(firestoreMedia);
          return;
        }
      } catch (error) {
        console.log('Firestore media fetch failed, falling back to JSON:', error);
      }
      // Fallback to JSON
      fetch(`${process.env.PUBLIC_URL}/media.json`)
        .then(res => res.json())
        .then(data => setMediaList(data))
        .catch(err => console.error('Error loading media:', err));
    };
    loadMedia();
  }, []);

  // Function to load/refresh course guides (can be called from child components)
  const refreshCourseGuides = async () => {
    try {
      const firestoreGuides = await getAllCourseGuides();
      setCourseGuides(firestoreGuides || []);
    } catch (error) {
      console.error('Error loading course guides:', error);
      setCourseGuides([]);
    }
  };

  useEffect(() => {
    refreshCourseGuides();
  }, []);



  // Helper to get city coordinates (first course in city)
  function getCityLatLng(cityState) {
    const [city, state] = cityState.split(',').map(s => s.trim());
    const found = golfCourses.find(c => c.city === city && c.state === state);
    return found ? { lat: found.lat, lng: found.lng } : null;
  }

  useEffect(() => {
    const courseId = searchParams.get('course');
    const lat = searchParams.get('lat');
    const lng = searchParams.get('lng');
    
    if (courseId && golfCourses.length > 0) {
      const found = golfCourses.find(c => c.course_id === courseId);
      if (found) {
        setSelectedCourse(found); // Always set from golfCourses
        const doFlyToCourse = () => {
          if (mapInstance.current) {
            const isMobile = window.innerWidth <= 768;
            const offset = isMobile ? [0, 0] : [300, -60];
            const currentZoom = mapInstance.current.getZoom ? mapInstance.current.getZoom() : 10;
            const zoomLevel = isMobile ? 10 : Math.max(currentZoom, 12);
            mapInstance.current.flyTo({
              center: [found.lng, found.lat],
              zoom: zoomLevel,
              essential: true,
              offset: offset
            });
            
            // Show tooltip after map finishes zooming (mobile only)
            if (isMobile) {
              setTimeout(() => {
                // Calculate position based on course coordinates instead of marker element
                const mapContainer = mapInstance.current.getContainer();
                const mapRect = mapContainer.getBoundingClientRect();
                const point = mapInstance.current.project([found.lng, found.lat]);
                
                const tooltipInfo = {
                  course: found,
                  position: {
                    x: point.x,
                    y: point.y - 4
                  },
                  sticky: true
                };

                setTooltipInfo(tooltipInfo);
              }, 1000); // Wait for flyTo animation to complete
            }
          }
        };
        if (mapInstance.current && mapInstance.current.isStyleLoaded && mapInstance.current.isStyleLoaded()) {
          doFlyToCourse();
        } else if (mapInstance.current) {
          mapInstance.current.once('style.load', doFlyToCourse);
        } else {
          // If mapInstance is not ready, retry after a short delay
          setTimeout(() => {
            if (mapInstance.current && mapInstance.current.isStyleLoaded && mapInstance.current.isStyleLoaded()) {
              doFlyToCourse();
            } else if (mapInstance.current) {
              mapInstance.current.once('style.load', doFlyToCourse);
            }
          }, 200);
        }
      }
    }
    
    // Handle lat/lng parameters from home page current location
    if (lat && lng) {
      const latitude = parseFloat(lat);
      const longitude = parseFloat(lng);
      
      if (!isNaN(latitude) && !isNaN(longitude)) {
        setPendingCoordinates({ lat: latitude, lng: longitude });
      }
    }
  }, [searchParams, golfCourses]);

  // Handle list parameters from URL
  useEffect(() => {
    const listParam = searchParams.get('list');
    
    if (listParam === 'live') {
      // Dynamic live list - fetch current list contents
      const fetchLiveList = async () => {
        try {
          const listType = searchParams.get('type');
          const userId = searchParams.get('user');
          const customListId = searchParams.get('listId');
          
          if (userId) {
            const userRef = doc(db, "users", userId);
            const userSnap = await getDoc(userRef);
            if (userSnap.exists()) {
              const userData = userSnap.data();
              
              if (listType === 'played') {
                const courseIds = userData.playedCourses || [];
                const listName = userData.playedListName || 'Played';
                setListCourseIds(courseIds);
                setListName(listName);
              } else if (listType === 'wishlist') {
                const courseIds = userData.wishlistCourses || [];
                const listName = userData.wishlistListName || 'Bucket List';
                setListCourseIds(courseIds);
                setListName(listName);
              } else if (listType === 'custom' && customListId) {
                const customList = userData.customLists?.[customListId];
                if (customList) {
                  setListCourseIds(customList.courses || []);
                  setListName(customList.name);
                } else {
                  setListCourseIds([]);
                  setListName('');
                }
              } else {
                setListCourseIds([]);
                setListName('');
              }
              return;
            }
          }
          
          setListCourseIds([]);
          setListName('');
        } catch (error) {
          console.error('Error fetching live list:', error);
          setListCourseIds([]);
          setListName('');
        }
      };
      
      fetchLiveList();
    } else if (listParam && (listParam.startsWith('played_') || listParam.startsWith('wishlist_') || listParam.startsWith('custom_'))) {
      // Database-based list snapshots (legacy support)
      const fetchListSnapshot = async () => {
        try {
          const snapshotId = listParam;
          const userId = searchParams.get('user');
          
          if (userId) {
            // Fetch the snapshot from the specified user's data
            const userRef = doc(db, "users", userId);
            const userSnap = await getDoc(userRef);
            if (userSnap.exists()) {
              const userData = userSnap.data();
              const snapshot = userData.listSnapshots?.[snapshotId];
              if (snapshot && snapshot.isActive) {
                setListCourseIds(snapshot.courseIds || []);
                setListName(snapshot.name || snapshot.type);
                return;
              }
            }
          }
          
          // Fallback: try current user if no user specified or snapshot not found
          if (user) {
            const userRef = doc(db, "users", user.uid);
            const userSnap = await getDoc(userRef);
            if (userSnap.exists()) {
              const userData = userSnap.data();
              const snapshot = userData.listSnapshots?.[snapshotId];
              if (snapshot && snapshot.isActive) {
                setListCourseIds(snapshot.courseIds || []);
                setListName(snapshot.name || snapshot.type);
                return;
              }
            }
          }
          
          setListCourseIds([]);
          setListName('');
        } catch (error) {
          console.error('Error fetching list snapshot:', error);
          setListCourseIds([]);
          setListName('');
        }
      };
      
      fetchListSnapshot();
    } else if (listParam && listParam.startsWith('list_')) {
      // Session storage format (fallback)
      const listData = sessionStorage.getItem(listParam);
      if (listData) {
        try {
          const parsed = JSON.parse(listData);
          setListCourseIds(parsed.courseIds || []);
          setListName(parsed.name || parsed.type);
        } catch (error) {
          console.error('Error parsing list data:', error);
          setListCourseIds([]);
          setListName('');
        }
      } else {
        setListCourseIds([]);
        setListName('');
      }
    } else if (listParam && searchParams.get('courseIds')) {
      // Legacy format: course IDs in URL (for backward compatibility)
      const courseIdsParam = searchParams.get('courseIds');
      const listNameParam = searchParams.get('listName');
      const courseIds = courseIdsParam.split(',').filter(id => id.trim());
      setListCourseIds(courseIds);
      setListName(listNameParam || listParam);
    } else {
      setListCourseIds([]);
      setListName('');
    }
  }, [searchParams, user]);

  // Real-time updates for live lists
  useEffect(() => {
    const listParam = searchParams.get('list');
    const listType = searchParams.get('type');
    const userId = searchParams.get('user');
    
    if (listParam === 'live' && userId && listType) {
      // Set up real-time listener for live lists
      const userRef = doc(db, "users", userId);
      const unsubscribe = onSnapshot(userRef, (doc) => {
        if (doc.exists()) {
          const userData = doc.data();
          
          if (listType === 'played') {
            const courseIds = userData.playedCourses || [];
            const listName = userData.playedListName || 'Played';
            setListCourseIds(courseIds);
            setListName(listName);
          } else if (listType === 'wishlist') {
            const courseIds = userData.wishlistCourses || [];
            const listName = userData.wishlistListName || 'Bucket List';
            setListCourseIds(courseIds);
            setListName(listName);
          } else if (listType === 'custom') {
            const customListId = searchParams.get('listId');
            if (customListId) {
              const customList = userData.customLists?.[customListId];
              if (customList) {
                setListCourseIds(customList.courses || []);
                setListName(customList.name);
              } else {
                setListCourseIds([]);
                setListName('');
              }
            }
          }
        }
      });
      
      return () => unsubscribe();
    }
  }, [searchParams, user]);

  // Clean up old session storage entries (older than 1 hour)
  useEffect(() => {
    const cleanupOldLists = () => {
      const oneHourAgo = Date.now() - (60 * 60 * 1000);
      Object.keys(sessionStorage).forEach(key => {
        if (key.startsWith('list_')) {
          const timestamp = parseInt(key.split('_')[1]);
          if (timestamp && timestamp < oneHourAgo) {
            sessionStorage.removeItem(key);
          }
        }
      });
    };
    
    // Clean up on component mount
    cleanupOldLists();
    
    // Set up periodic cleanup (every 30 minutes)
    const interval = setInterval(cleanupOldLists, 30 * 60 * 1000);
    
    return () => clearInterval(interval);
  }, []);
  // Handler for played checkbox
  const handlePlayedChange = async (e, courseId) => {
    if (!user) return;
    const userRef = doc(db, "users", user.uid);
    let updated;
    if (e.target.checked) {
      await updateDoc(userRef, { playedCourses: arrayUnion(courseId) });
      updated = [...playedCourses, courseId];
    } else {
      await updateDoc(userRef, { playedCourses: arrayRemove(courseId) });
      updated = playedCourses.filter(cid => cid !== courseId);
    }
    setPlayedCourses(updated);
    
    // Update any active played list snapshots
    try {
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        const userData = userSnap.data();
        if (userData?.listSnapshots) {
          const updates = {};
          Object.entries(userData.listSnapshots).forEach(([snapshotId, snapshot]) => {
            if (snapshot.type === 'played' && snapshot.isActive) {
              updates[`listSnapshots.${snapshotId}.courseIds`] = updated;
            }
          });
          if (Object.keys(updates).length > 0) {
            await updateDoc(userRef, updates);
          }
        }
      }
    } catch (error) {
      console.error('Error updating list snapshots:', error);
    }
  };
  // Handler for wishlist button
  const handleWishlistChange = async (courseId) => {
    if (!user) return;
    const userRef = doc(db, "users", user.uid);
    let updated;
    if (!wishlistCourses.includes(courseId)) {
      await updateDoc(userRef, { wishlistCourses: arrayUnion(courseId) });
      updated = [...wishlistCourses, courseId];
    } else {
      await updateDoc(userRef, { wishlistCourses: arrayRemove(courseId) });
      updated = wishlistCourses.filter(cid => cid !== courseId);
    }
    setWishlistCourses(updated);
    
    // Update any active wishlist snapshots
    try {
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        const userData = userSnap.data();
        if (userData?.listSnapshots) {
          const updates = {};
          Object.entries(userData.listSnapshots).forEach(([snapshotId, snapshot]) => {
            if (snapshot.type === 'wishlist' && snapshot.isActive) {
              updates[`listSnapshots.${snapshotId}.courseIds`] = updated;
            }
          });
          if (Object.keys(updates).length > 0) {
            await updateDoc(userRef, updates);
          }
        }
      }
    } catch (error) {
      console.error('Error updating list snapshots:', error);
    }
  };

  // Set default types for course type filter
  const defaultTypes = [
    "Public",
    "Municipal",
    "Semi-Private",
    "Resort",
    "University",
    "Military",
    "Private"
  ];
  const isDefaultTypes = selectedTypes.length === defaultTypes.length && defaultTypes.every(t => selectedTypes.includes(t));
  const isDefaultRanked = rankedOnly === false;
  const isCourseTypeDefault = isDefaultTypes && isDefaultRanked;

  // Add this effect to handle ?search=... param from the URL
  useEffect(() => {
    if (location.pathname === '/map') {
      const urlSearch = searchParams.get('search');
      if (urlSearch && urlSearch !== searchTerm && !hasUserTyped.current) {
        setSearchTerm(urlSearch);
      }
    }
  }, [location.pathname, searchParams, searchTerm]);

  // New effect: when searchTerm changes and ?search=... is present, trigger handleSearch only after map is loaded
  useEffect(() => {
    if (location.pathname === '/map' && mapLoaded) {
      const urlSearch = searchParams.get('search');
      if (urlSearch && searchTerm === urlSearch) {
        handleSearch();
      }
    }
  }, [searchTerm, location.pathname, searchParams, mapLoaded]);

  // Reset the hasUserTyped flag when navigating away from the map page
  useEffect(() => {
    if (location.pathname !== '/map') {
      hasUserTyped.current = false;
      hasHandledSearchParam.current = false;
    }
  }, [location.pathname]);

  // On map page load, if there's a ?search=... param, use the geocoder-based search
  useEffect(() => {
    if (
      location.pathname === '/map' &&
      mapLoaded &&
      searchParams.get('search') &&
      !hasUserTyped.current &&
      !hasHandledSearchParam.current
    ) {
      const urlSearch = searchParams.get('search');
      setSearchTerm(urlSearch);
      hasHandledSearchParam.current = true;
      handleSearch(urlSearch);
    }
    // eslint-disable-next-line
  }, [location.pathname, mapLoaded, searchParams]);

  // Handle course parameter from URL (when navigating from home page)
  useEffect(() => {
    if (
      location.pathname === '/map' &&
      mapLoaded &&
      searchParams.get('course') &&
      searchParams.get('lat') &&
      searchParams.get('lng')
    ) {
      const courseId = searchParams.get('course');
      const lat = parseFloat(searchParams.get('lat'));
      const lng = parseFloat(searchParams.get('lng'));
      
      if (mapInstance.current) {
        const flyToOptions = {
          center: [lng, lat],
          zoom: 15,
          essential: true,
        };
        if (!isMobile) {
          flyToOptions.offset = [300, 0];
        }
        mapInstance.current.flyTo(flyToOptions);
        
        // Find and select the course
        const course = golfCourses.find(c => c.course_id === courseId);
        if (course) {
          setSelectedCourse(course);
          setTooltipInfo(null);
          setSearchTerm(course.name);
        }
      }
    }
  }, [location.pathname, mapLoaded, searchParams, golfCourses, isMobile]);

  // Marker position check for tap detection
  const markerTouchStartRect = useRef(null);
  const POSITION_TOLERANCE = 2; // px

  const handleTouchStart = (e, course) => {
    if (isMobile) {
      // Find the marker element
      const marker = markersRef.current[course.course_id];
      if (marker && marker.element) {
        markerTouchStartRect.current = marker.element.getBoundingClientRect();
      } else {
        markerTouchStartRect.current = null;
      }
    }
  };

  const handleTouchEnd = (e, course) => {
    if (!isMobile) return;
    const marker = markersRef.current[course.course_id];
    if (!marker || !marker.element || !markerTouchStartRect.current) {
      markerTouchStartRect.current = null;
      return;
    }
    const endRect = marker.element.getBoundingClientRect();
    const startRect = markerTouchStartRect.current;
    // Compare positions (allowing for a small tolerance)
    const samePosition =
      Math.abs(endRect.left - startRect.left) < POSITION_TOLERANCE &&
      Math.abs(endRect.top - startRect.top) < POSITION_TOLERANCE;
    if (samePosition) {
      setSelectedCourse(course);
      Object.values(markersRef.current).forEach(({ element }) => {
        if (element) {
          element.classList.remove("selected");
        }
      });
      if (marker.element) {
        marker.element.classList.add("selected");
      }
    }
    markerTouchStartRect.current = null;
  };

  const handleTouchCancel = () => {
    markerTouchStartRect.current = null;
  };

  // Track map movement and always cancel marker touch if map moves
  useEffect(() => {
    if (mapInstance.current) {
      const map = mapInstance.current;
      const cancelMarkerTouch = () => {
        markerTouchStartRect.current = null;
      };
      map.on('movestart', cancelMarkerTouch);
      map.on('move', cancelMarkerTouch);
      map.on('zoomstart', cancelMarkerTouch);
      map.on('zoom', cancelMarkerTouch);
      return () => {
        map.off('movestart', cancelMarkerTouch);
        map.off('move', cancelMarkerTouch);
        map.off('zoomstart', cancelMarkerTouch);
        map.off('zoom', cancelMarkerTouch);
      };
    }
  }, [mapInstance.current]);



  // --- CLUSTERING SYSTEM REFACTOR START ---
  // Robust clustering system for map and sidebar with dynamic max points and priority filtering
  const [geojson, setGeojson] = useState(null);
  const [clusters, setClusters] = useState([]);
  const [sidebarCourses, setSidebarCourses] = useState([]); // Separate state for sidebar
  const superclusterRef = useRef(null);
  const MAX_POINTS = 50;
  const MAX_CLUSTER_COURSES = 500;

  // Memoized filtered courses - like SpecializedMap for performance
  const filteredCourses = useMemo(() => {
    if (!golfCourses || golfCourses.length === 0) return [];
    
    return golfCourses.filter((course) => {
      const priceValue = (course.price && parseInt(course.price.replace(/\D/g, ""))) || 0;
      const matchesPrice =
        (minPrice === null || priceValue >= minPrice) &&
        (maxPrice === null || priceValue <= maxPrice);
      const matchesType = selectedTypes.length === 0 || selectedTypes.some(type => 
        type.toLowerCase() === (course.type || '').toLowerCase()
      );
      const matchesEighteen = !selectedTypes.includes("18 Holes") || course.number_of_holes >= 18;
      const matchesArchitect = selectedArchitects.length === 0 || selectedArchitects.includes(course.course_architect);
      const matchesRanked = recommendedRankedOnly ? (course.top100_state_rank && course.top100_state_rank !== '') : (!rankedOnly || (course.top100_state_rank && course.top100_state_rank !== ''));
      const matchesMedia = !hasMediaOnly || courseHasMedia(course, mediaList);
      const matchesMediaTypes = selectedMediaTypes.length === 0 || selectedMediaTypes.some(type => 
        mediaList.some(m => m.course_id === course.course_id && m.media_type === type)
      );
      const matchesNotableArchitects = !recommendedNotableArchitects || (course.notable_architect && course.notable_architect !== 'N');
      const matchesAppearsInGuide = !recommendedAppearsInGuide || courseGuides.some(guide => guide.course_id === course.course_id);
      const matchesAnyRecommended = !recommendedAnyRecommended || (
        (course.top100_state_rank && course.top100_state_rank !== '') ||
        (course.notable_architect && course.notable_architect !== 'N') ||
        courseGuides.some(guide => guide.course_id === course.course_id)
      );
      const matchesTop100All = !top100AllOnly || (course.GD100all_rank && course.GD100all_rank !== '');
      const matchesTop100Public = !top100PublicOnly || (course.GD100pub_rank && course.GD100pub_rank !== '');
      const matchesList = listCourseIds.length === 0 || listCourseIds.includes(course.course_id);
      
      return matchesPrice && matchesType && matchesEighteen && 
             matchesArchitect && matchesRanked && matchesMedia && 
             matchesMediaTypes && matchesNotableArchitects && matchesAppearsInGuide && matchesAnyRecommended && 
             matchesTop100All && matchesTop100Public && matchesList;
    });
  }, [golfCourses, mediaList, selectedTypes, minPrice, maxPrice, selectedArchitects, rankedOnly, hasMediaOnly, selectedMediaTypes, recommendedRankedOnly, recommendedNotableArchitects, recommendedAppearsInGuide, courseGuides, recommendedAnyRecommended, listCourseIds, top100AllOnly, top100PublicOnly]);

  // Helper: get top N prioritized courses in bounds
  function getTopCoursesInBounds(bounds, center, N) {
    // Add a small buffer to bounds to reduce edge popping
    const buffer = 0.01;
    const minLat = bounds.getSouth() - buffer;
    const maxLat = bounds.getNorth() + buffer;
    const minLng = bounds.getWest() - buffer;
    const maxLng = bounds.getEast() + buffer;

    // Only filter by bounds since filteredCourses is already filtered by other criteria
    const filtered = filteredCourses.filter((course) => {
      return course.lat >= minLat &&
             course.lat <= maxLat &&
             course.lng >= minLng &&
             course.lng <= maxLng;
    });

    const group1 = [], group2 = [];
    filtered.forEach(course => {
      const hasNationalRank = !!(course.GD100all_rank && course.GD100all_rank !== '');
      const hasPublicRank = !!(course.GD100pub_rank && course.GD100pub_rank !== '');
      const hasStateRank = !!(course.top100_state_rank && course.top100_state_rank !== '');
      const isRanked = hasNationalRank || hasPublicRank || hasStateRank;
      if (isRanked) {
        group1.push(course);
      } else {
        group2.push(course);
      }
    });
    
    // Sort ranked courses by priority: Public > National > State > Price
    group1.sort((a, b) => {
      // First priority: GD100pub_rank (Public ranking)
      const aPublicRank = parseInt(a.GD100pub_rank) || 999;
      const bPublicRank = parseInt(b.GD100pub_rank) || 999;
      if (aPublicRank !== bPublicRank) return aPublicRank - bPublicRank;
      
      // Second priority: GD100all_rank (National ranking)
      const aNationalRank = parseInt(a.GD100all_rank) || 999;
      const bNationalRank = parseInt(b.GD100all_rank) || 999;
      if (aNationalRank !== bNationalRank) return aNationalRank - bNationalRank;
      
      // Third priority: top100_state_rank (State ranking)
      const aStateRank = parseInt(a.top100_state_rank) || 999;
      const bStateRank = parseInt(b.top100_state_rank) || 999;
      if (aStateRank !== bStateRank) return aStateRank - bStateRank;
      
      // Fourth priority: Price (higher price first)
      const aPrice = (a.price && parseInt(a.price.replace(/\D/g, ""))) || 0;
      const bPrice = (b.price && parseInt(b.price.replace(/\D/g, ""))) || 0;
      return bPrice - aPrice;
    });
    
    // Sort unranked courses by distance from center
    group2.sort((a, b) => {
      const distA = Math.sqrt(Math.pow(a.lat - center.lat, 2) + Math.pow(a.lng - center.lng, 2));
      const distB = Math.sqrt(Math.pow(b.lat - center.lat, 2) + Math.pow(b.lng - center.lng, 2));
      return distA - distB;
    });
    
    const pinLimit = 500;
    const visible = [];
    for (const course of group1) { if (visible.length < pinLimit) visible.push(course); else break; }
    for (const course of group2) { if (visible.length < pinLimit) visible.push(course); else break; }
    return visible.length < pinLimit ? visible : visible.slice(0, pinLimit);
  }

  // Load GeoJSON and initialize Supercluster - only once like SpecializedMap
  useEffect(() => {
    if (!mapLoaded) return;
    if (!mapInstance.current) return;
    
    fetch(`${process.env.PUBLIC_URL}/geo_courses.json`)
      .then(res => res.json())
      .then(data => {
        if (!mapInstance.current) return;
        setGeojson(data);
        // Function to calculate radius based on zoom level
        const getClusterRadius = (zoom) => {
          const desktopRadius = 
            zoom >= 14 ? 20 :
            zoom >= 12 ? 30 :
            zoom >= 10 ? 40 :
            zoom >= 8 ? 50 :
            zoom >= 6 ? 60 :
            70;

          // Use a smaller radius on mobile to prevent distant courses from clustering
          return isMobile ? desktopRadius * 0.7 : desktopRadius;
        };

        superclusterRef.current = new Supercluster({
          radius: getClusterRadius(mapInstance.current.getZoom()),
          maxZoom: 16,
          minPoints: 2,
          initial: () => ({
            getClusterRadius: getClusterRadius
          })
        });
        
        // Initial cluster update
        updateClusters();
      });
  }, [mapLoaded, isMobile]);

  // Memoized updateClusters - simplified like SpecializedMap
  const updateClusters = React.useCallback(() => {
    if (!superclusterRef.current || !mapInstance.current || !geojson) {
      return;
    }
    
    const bounds = mapInstance.current.getBounds();
    const zoom = Math.round(mapInstance.current.getZoom());
    const center = mapInstance.current.getCenter();
    
    // Update cluster radius based on current zoom
    if (superclusterRef.current.options.initial) {
      const getClusterRadius = superclusterRef.current.options.initial().getClusterRadius;
      superclusterRef.current.options.radius = getClusterRadius(zoom);
    }
    
    const topCourses = getTopCoursesInBounds(bounds, { lat: center.lat, lng: center.lng }, MAX_CLUSTER_COURSES);
    
    // Always update sidebar courses with the top courses in bounds
    setSidebarCourses(topCourses);
    
    if (zoom >= 16) {
      // At very high zoom, show all as singles (no clustering)
      const features = topCourses.map(course => ({
        type: "Feature",
        geometry: { type: "Point", coordinates: [course.lng, course.lat] },
        properties: { ...course, cluster: false }
      }));
      setClusters(features);
      return;
    }
    
    const features = topCourses.map(course => ({
      type: "Feature",
      geometry: { type: "Point", coordinates: [course.lng, course.lat] },
      properties: { ...course }
    }));
    
    superclusterRef.current.load(features);
    let clusterResults = superclusterRef.current.getClusters(
      [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()],
      zoom
    );

    // First, separate clusters and points
    const clusterPoints = clusterResults.filter(f => f.properties.cluster);
    const singlePoints = clusterResults.filter(f => !f.properties.cluster);
    
    // Only filter singles if we're at a lower zoom level
    let filteredSingles = singlePoints;
    if (zoom < 12) { // Only apply distance filtering when zoomed out
      const threshold = 0.05 * (16 - zoom) / 13; // Dynamic threshold that reduces as you zoom in
      
      filteredSingles = singlePoints.filter(single => {
        const [singleLng, singleLat] = single.geometry.coordinates;
        // Check if this single point is too close to any cluster
        return !clusterPoints.some(cluster => {
          const [clusterLng, clusterLat] = cluster.geometry.coordinates;
          const distance = Math.sqrt(
            Math.pow(clusterLng - singleLng, 2) + 
            Math.pow(clusterLat - singleLat, 2)
          );
          return distance < threshold;
        });
      });
    }
    
    // Combine filtered singles with clusters
    clusterResults = [...clusterPoints, ...filteredSingles];
    
    setClusters(clusterResults);
  }, [geojson, filteredCourses, isMobile]);

  // Reset clustering system - equivalent to refreshing the page


  // Listen for map move/zoom to update clusters (always latest updateClusters)
  useEffect(() => {
    if (!isMapPage || !mapInstance.current) return;
    const map = mapInstance.current;
    
    // Create stable event handlers that always call the current updateClusters
    const handleMoveEnd = () => {
      if (typeof updateClusters === 'function') {
        updateClusters();
      }
    };
    
    const handleZoomEnd = () => {
      if (typeof updateClusters === 'function') {
        updateClusters();
      }
    };
    
    // Remove any existing listeners first to avoid duplicates
    map.off("moveend", handleMoveEnd);
    map.off("zoomend", handleZoomEnd);
    
    map.on("moveend", handleMoveEnd);
    map.on("zoomend", handleZoomEnd);
    
    return () => {
      if (map && !map._removed) {
        map.off("moveend", handleMoveEnd);
        map.off("zoomend", handleZoomEnd);
      }
    };
  }, [isMapPage, mapInstance.current]); // Add mapInstance.current to dependencies to ensure listeners are reattached when map changes

  // Ensure clusters update when geojson or map is ready
  useEffect(() => {
    if (geojson && mapInstance.current) {
      if (typeof updateClusters === 'function') {
        updateClusters();
      }
    }
  }, [geojson, mapInstance.current, golfCourses, mediaList]); // Remove updateClusters dependency

  // Handle pending coordinates from home page when map is ready
  useEffect(() => {
    if (pendingCoordinates && mapInstance.current && mapLoaded) {
      
      const { lat, lng } = pendingCoordinates;
      const map = mapInstance.current;
              const doFly = () => {
          try {
            map.flyTo({
              center: [lng, lat],
              zoom: 10,
              essential: true,
              offset: [300, 0]
            });
            setTimeout(() => {
              setSearchTerm('Current Location');
              setPendingCoordinates(null); // Only clear after successful marker/zoom
            }, 1000);
          } catch (e) {
            console.error('Error in flyTo:', e);
          }
        };
      if (map.isStyleLoaded()) {
        doFly();
      } else {
        map.once('style.load', doFly);
      }
    }
  }, [pendingCoordinates, mapLoaded, mapInstance.current, isMobile]);

  // Update clusters when any filter changes
  useEffect(() => {
    if (mapInstance.current) {
      if (typeof updateClusters === 'function') {
        updateClusters();
      }
    }
  }, [selectedTypes, minPrice, maxPrice, selectedArchitects, rankedOnly, hasMediaOnly, selectedMediaTypes, recommendedRankedOnly, recommendedNotableArchitects, recommendedAppearsInGuide, courseGuides, recommendedAnyRecommended, listCourseIds]);

  // Remove the homepage reset approach - it's causing more problems than it solves
  
  // --- CLUSTERING SYSTEM REFACTOR END ---

  // Helper: group features by proximity
  function groupByProximity(features, threshold = 0.0005) {
    const groups = [];
    features.forEach(f => {
      let group = groups.find(g => g.some(o => Math.abs(o.geometry.coordinates[0] - f.geometry.coordinates[0]) < threshold && Math.abs(o.geometry.coordinates[1] - f.geometry.coordinates[1]) < threshold));
      if (!group) {
        group = [];
        groups.push(group);
      }
      group.push(f);
    });
    return groups;
  }

  // Improved spiderfy: always spiderfy groups with >1 feature at high zoom
  function improvedSpiderfy(features, zoom) {
    if (zoom < 15) return features;
    const groups = groupByProximity(features);
    let spiderfied = [];
    groups.forEach(group => {
      if (group.length === 1) {
        spiderfied.push(group[0]);
      } else {
        const angleStep = (2 * Math.PI) / group.length;
        const radius = 0.0008;
        group.forEach((f, i) => {
          const angle = i * angleStep;
          const dx = Math.cos(angle) * radius;
          const dy = Math.sin(angle) * radius;
          spiderfied.push({
            ...f,
            geometry: {
              ...f.geometry,
              coordinates: [
                f.geometry.coordinates[0] + dx,
                f.geometry.coordinates[1] + dy
              ]
            },
            properties: {
              ...f.properties,
              spiderfied: true,
              spiderfiedIndex: i,
              spiderfiedCount: group.length
            }
          });
        });
      }
    });
    return spiderfied;
  }

  // 2. Manage markers in a separate effect - clean like SpecializedMap
  useEffect(() => {
    const map = mapInstance.current;
    if (!mapLoaded) return;
    if (!map) return;
    if (!golfCourses || golfCourses.length === 0) return;
    if (!clusters || clusters.length === 0) return;
    
    // Remove all existing markers
    if (map.getContainer()) {
      const markers = document.getElementsByClassName('maplibregl-marker');
      while (markers.length > 0) {
        markers[0].remove();
      }
    }
    markersRef.current = {};
    
    const zoom = Math.round(map.getZoom());
    
    // Render markers from clusters
    clusters.forEach(cluster => {
      const [lng, lat] = cluster.geometry.coordinates;
      let el;
      
      if (cluster.properties.cluster) {
        // Cluster marker
        el = document.createElement("div");
        el.style.background = "#222";
        el.style.color = "#fff";
        el.style.borderRadius = "50%";
        el.style.width = "24px";
        el.style.height = "24px";
        el.style.display = "flex";
        el.style.alignItems = "center";
        el.style.justifyContent = "center";
        el.style.fontWeight = "bold";
        el.style.fontSize = "11px";
        el.style.boxShadow = "0 2px 8px rgba(0,0,0,0.18)";
        el.innerText = cluster.properties.point_count_abbreviated;
        el.style.cursor = "pointer";
        el.style.border = "2px solid #fff";
        
        // Add hover effect for green circle only (match SpecializedMap exactly)
        el.addEventListener("mouseenter", () => {
          el.style.boxShadow = "0 0 0 4px #1D665D, 0 2px 8px rgba(0,0,0,0.18)";
        });
        el.addEventListener("mouseleave", () => {
          el.style.boxShadow = "0 2px 8px rgba(0,0,0,0.18)";
        });

        el.addEventListener("click", () => {
          const expansionZoom = Math.min(
            superclusterRef.current.getClusterExpansionZoom(cluster.id),
            18
          );
          
          const flyToOptions = {
            center: [lng, lat],
            zoom: expansionZoom,
            essential: true
          };

          if (!isMobile) {
            flyToOptions.offset = [300, 0]; // Use your sidebar width
          }
          
          map.flyTo(flyToOptions);
        });
      } else {
        // Single course marker
        el = document.createElement("div");
        const photoUrl = cluster.properties.photo_url || cluster.properties.image || null;
        if (photoUrl) {
          el.style.width = "36px";
          el.style.height = "36px";
          el.style.borderRadius = "50%";
          el.style.overflow = "hidden";
          el.style.boxShadow = "0 2px 8px rgba(0,0,0,0.18)";
          el.style.border = "2px solid #fff";
          el.innerHTML = `<img src='${photoUrl}' alt='' style='width:100%;height:100%;object-fit:cover;border-radius:50%;' />`;
        } else {
          el.style.width = "18px";
          el.style.height = "18px";
          el.style.background = "#222";
          el.style.borderRadius = "50%";
          el.style.border = "2px solid #fff";
          el.style.boxShadow = "0 2px 8px rgba(0,0,0,0.18)";
        }
        el.style.cursor = "pointer";
          
        el.addEventListener("mouseenter", (e) => {
          if (justClickedRef.current) return;
          if (tooltipInfo && tooltipInfo.sticky) return;
          el.style.boxShadow = "0 0 0 4px #1D665D, 0 2px 8px rgba(0,0,0,0.18)";
          if (tooltipTimeoutRef.current) { clearTimeout(tooltipTimeoutRef.current); }
          const rect = el.getBoundingClientRect();
          const mapContainer = map.getContainer();
          const mapRect = mapContainer.getBoundingClientRect();
          tooltipTimeoutRef.current = setTimeout(() => {
            setTooltipInfo({
              course: cluster.properties,
              position: { x: rect.left - mapRect.left + rect.width / 2, y: rect.top - mapRect.top - 4 },
              sticky: false
            });
          }, 200);
        });
        
        el.addEventListener("mouseleave", () => {
          if (!selectedCourse || selectedCourse.course_id !== cluster.properties.course_id) {
            el.style.boxShadow = photoUrl ? "0 2px 8px rgba(0,0,0,0.18)" : "0 2px 8px rgba(0,0,0,0.18)";
          }
          if (tooltipTimeoutRef.current) {
            clearTimeout(tooltipTimeoutRef.current);
            tooltipTimeoutRef.current = null;
          }
          // Always hide non-sticky tooltips when mouse leaves
          setTooltipInfo(currentTooltipInfo => {
            if (currentTooltipInfo && !currentTooltipInfo.sticky) {
              return null;
            }
            return currentTooltipInfo;
          });
        });

        el.addEventListener("click", (e) => {
          e.stopPropagation();

          justClickedRef.current = true;
          setTimeout(() => {
            justClickedRef.current = false;
          }, 300);

          if (tooltipTimeoutRef.current) {
            clearTimeout(tooltipTimeoutRef.current);
            tooltipTimeoutRef.current = null;
          }
          if (tooltipInfo && !tooltipInfo.sticky) {
            setTooltipInfo(null);
          }

          const clickedCourse = cluster.properties;

          if (isMobile) {
            const rect = el.getBoundingClientRect();
            const mapContainer = map.getContainer();
            const mapRect = mapContainer.getBoundingClientRect();
            setTooltipInfo({
              course: clickedCourse,
              position: {
                x: rect.left - mapRect.left + rect.width / 2,
                y: rect.top - mapRect.top - 4
              },
              sticky: true
            });
          } else {
            setSelectedCourse(clickedCourse);
          }
        });
      }
      
      const marker = new maplibregl.Marker({ element: el })
        .setLngLat([lng, lat])
        .addTo(map);
      
      // Use cluster.id for clusters, cluster.properties.course_id for individual markers - exactly like SpecializedMap
      const key = cluster.properties.cluster ? cluster.id : cluster.properties.course_id;
      markersRef.current[key] = { marker, element: el };
    });
    
    // Highlight selected marker
    if (selectedCourse && markersRef.current[selectedCourse.course_id]) {
      markersRef.current[selectedCourse.course_id].element.style.boxShadow = "0 0 0 4px #1D665D, 0 2px 8px rgba(0,0,0,0.18)";
    }
    
    return () => {
      if (map.getContainer()) {
        const markers = document.getElementsByClassName('maplibregl-marker');
        while (markers.length > 0) {
          markers[0].remove();
        }
      }
      markersRef.current = {};
    };
  }, [clusters, selectedCourse, mapLoaded, isMobile]);

  // Listen for map move/zoom to update clusters - clean like SpecializedMap
  useEffect(() => {
    if (!mapLoaded || !mapInstance.current) return;
    const map = mapInstance.current;
    
    const handleClusterUpdate = () => {
      updateClusters();
    };
    
    map.on("moveend", handleClusterUpdate);
    map.on("zoomend", handleClusterUpdate);
    return () => {
      map.off("moveend", handleClusterUpdate);
      map.off("zoomend", handleClusterUpdate);
    };
  }, [mapLoaded, updateClusters]);

  // Update clusters when any filter changes - like SpecializedMap
  useEffect(() => {
    if (mapLoaded) {
      updateClusters();
    }
  }, [filteredCourses, mapLoaded]);

  // Add this new effect to close the sticky tooltip when clicking on the map
  useEffect(() => {
    if (!mapInstance.current) return;
    const map = mapInstance.current;
    
    const handleMapClick = () => {
      if (tooltipInfo && tooltipInfo.sticky) {
        setTooltipInfo(null);
      }
    };
    
    map.on('click', handleMapClick);
    
    return () => {
      if (map) {
        map.off('click', handleMapClick);
      }
    };
  }, [tooltipInfo]);

  // Cleanup effect to clear timeouts when component unmounts
  useEffect(() => {
    return () => {
      if (tooltipTimeoutRef.current) {
        clearTimeout(tooltipTimeoutRef.current);
        tooltipTimeoutRef.current = null;
      }
      justClickedRef.current = false;
    };
  }, []);

  // Cleanup current location marker on unmount
  useEffect(() => {
    return () => {
      if (currentLocationMarker) {
        currentLocationMarker.remove();
      }
    };
  }, [currentLocationMarker]);

  // This effect ensures the tooltip stays anchored to its marker during map movement.
  useEffect(() => {
    const map = mapInstance.current;
    if (!map || !tooltipInfo) return;

    const updatePosition = () => {
      setTooltipInfo(currentTooltipInfo => {
        if (!currentTooltipInfo) return null;

        const markerElement = getMarkerElementForCourse(currentTooltipInfo.course);
        if (markerElement) {
          const rect = markerElement.getBoundingClientRect();
          const mapContainer = map.getContainer();
          const mapRect = mapContainer.getBoundingClientRect();
        
        const newPosition = {
            x: rect.left - mapRect.left + rect.width / 2,
            y: rect.top - mapRect.top - 4,
        };
        
        return { ...currentTooltipInfo, position: newPosition };
        }
        
        return null;
      });
    };

    map.on('move', updatePosition);
    map.on('zoom', updatePosition);

    return () => {
      if (map) {
        map.off('move', updatePosition);
        map.off('zoom', updatePosition);
      }
    };
  }, [tooltipInfo]);

  // Cluster hover card cleanup removed - simplifying to just use tooltips like the specialized map



  // Remove aggressive cleanup - let the natural mouseleave handlers manage tooltips like SpecializedMap

  // Helper function to find which cluster contains a specific course
  const findClusterForCourse = (course) => {
    if (!clusters || !mapInstance.current) {
      return null;
    }
    
    const zoom = Math.round(mapInstance.current.getZoom());
    // Use appropriate thresholds for specialized map clustering
    // At very low zoom levels, clusters can be very large, so we need more generous thresholds
    let threshold;
    if (zoom >= 15) {
      threshold = 0.1; // High zoom - precise
    } else if (zoom >= 10) {
      threshold = 0.5; // Medium zoom - standard
    } else if (zoom >= 6) {
      threshold = 1.0; // Low zoom - generous
    } else {
      threshold = 2.0; // Very low zoom - very generous
    }
    
    // First, look for individual course markers (non-clusters) - use course_id for consistency
    const individualCluster = clusters.find(c => 
      !c.properties.cluster && c.properties.course_id === course.course_id
    );
    if (individualCluster) {
      return individualCluster;
    }
    
    // For clusters, find the closest one within threshold OR check if course is contained within cluster bounds
    let closestCluster = null;
    let closestDistance = Infinity;
    
    clusters.forEach(c => {
      if (!c.properties.cluster) return;
      
      const [clusterLng, clusterLat] = c.geometry.coordinates;
      const distance = Math.sqrt(
        Math.pow(clusterLng - course.lng, 2) + 
        Math.pow(clusterLat - course.lat, 2)
      );
      
      // Check if course is within threshold OR if it's likely contained within this cluster
      // At lower zoom levels, clusters can be quite large, so we need a more generous check
      const isWithinThreshold = distance < threshold;
      const isLikelyContained = distance < (threshold * 2); // More generous check for containment
      
      if ((isWithinThreshold || isLikelyContained) && distance < closestDistance) {
        closestDistance = distance;
        closestCluster = c;
      }
    });
    
    return closestCluster;
  };

  // Helper function to get marker element for a course (individual or cluster)
  const getMarkerElementForCourse = (course) => {
    const cluster = findClusterForCourse(course);
    if (!cluster) {
      return null;
    }
    
    // Use the same key logic as SpecializedMap for consistent behavior
    const key = cluster.properties.cluster ? cluster.id : (cluster.properties.course_id || cluster.properties.name);
    
    const markerRef = markersRef.current[key];
    if (!markerRef) {
      return null;
    }
    
    const markerElement = markerRef.element;
    if (!markerElement) {
      return null;
    }
    
    return markerElement;
  };

  // Remove unused marker highlighting functions - using direct DOM manipulation like SpecializedMap





  // Remove unused helper functions - simplified like SpecializedMap

  // Removed useEffect - marker is now created directly in handleCurrentLocation callback

  // On map page mount, check for window._pendingCoordinates or lat/lng query params and set pendingCoordinates
  useEffect(() => {
    if (!isMapPage) return;
    if (window._pendingCoordinates) {
      setPendingCoordinates(window._pendingCoordinates);
      window._pendingCoordinates = null;
    } else {
      const params = new URLSearchParams(window.location.search);
      const lat = params.get('lat');
      const lng = params.get('lng');
      if (lat && lng) {
        setPendingCoordinates({ lat: parseFloat(lat), lng: parseFloat(lng) });
      }
    }
    // Only run on mount
    // eslint-disable-next-line
  }, [isMapPage]);

  // On map page mount or URL change, check for lat/lng query params and set pendingCoordinates
  useEffect(() => {
    if (!isMapPage) return;
    const params = new URLSearchParams(location.search);
    const lat = params.get('lat');
    const lng = params.get('lng');
    if (lat && lng) {
      // Check if this is a current location request (no course parameter) or a course request
      const isCurrentLocation = !searchParams.get('course');
      const coords = { 
        lat: parseFloat(lat), 
        lng: parseFloat(lng),
        isCurrentLocation: isCurrentLocation
      };
      setPendingCoordinates(coords);
      pendingCoordinatesRef.current = coords;
    }
    // Only run on mount or URL change
    // eslint-disable-next-line
  }, [isMapPage, location.search]);

  // Handler for marker/sidecard click
  const handleProtectedInteraction = (action) => {
    if (!user) {
      setShowSignInPrompt(true);
      return;
    }
    action();
  };

  // Helper to require sign-in for filter changes
  function requireSignInOr(fn) {
    return function(...args) {
      if (!user) {
        setShowSignInPrompt(true);
        return;
      }
      return fn(...args);
    };
  }

  useEffect(() => {
    const map = mapInstance.current;
    if (!mapLoaded || !map || !selectedCourse) return;
    if (!clusters || clusters.length === 0) return;
    if (lastFlownToCourseId.current === selectedCourse.course_id) return;
    const isMobile = window.innerWidth <= 768;
    const offset = isMobile ? [0, 0] : [300, -60];
    const currentZoom = map.getZoom ? map.getZoom() : 10;
    const zoomLevel = isMobile ? 10 : Math.max(currentZoom, 12);
    map.flyTo({
      center: [selectedCourse.lng, selectedCourse.lat],
      zoom: zoomLevel,
      essential: true,
      offset: offset
    });
    lastFlownToCourseId.current = selectedCourse.course_id;
  }, [selectedCourse, mapLoaded, clusters]);

  return (
    <Routes>
      <Route path="/" element={<Articles />} />
      <Route path="/map" element={
        <div className="app-container">
          <Helmet>
            <title>Golf Near Me Map</title>
            <meta name="description" content="Interactive map showing golf courses near you. Find and explore golf courses with detailed information, reviews, and course guides." />
          </Helmet>
          <div className="top-bar">
            <div className="top-bar-left">
              {isMobile && (
                <button className="contact-button mobile-menu-button" onClick={toggleMobileMenu}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ marginRight: 0, verticalAlign: 'middle' }}
                  >
                    <rect x="3" y="5" width="18" height="2.5" rx="1.25" fill="currentColor" />
                    <rect x="6" y="10.75" width="12" height="2.5" rx="1.25" fill="currentColor" />
                    <rect x="9" y="16.5" width="6" height="2.5" rx="1.25" fill="currentColor" />
                  </svg>
                </button>
              )}
              <LocationSearchBar
                    value={searchTerm}
                    onChange={(e) => {
                      hasUserTyped.current = true;
                      setSearchTerm(e.target.value);
                    }}
                onSearch={handleSearch}
                filteredResults={filteredResults}
                onSelectResult={handleSelectResult}
                placeholder="Search by city, state, or course..."
                loading={golfCourses.length === 0}
                    onFocus={() => setShowCityDropdown(true)}
                    onBlur={() => {
                      // Only trigger search on blur if a suggestion wasn't clicked
                      if (!isSuggestionClicked) {
                        setTimeout(() => {
                          setShowCityDropdown(false);
                          handleSearch();
                        }, 120);
                      }
                      // Reset the flag
                      setIsSuggestionClicked(false);
                    }}
                showDropdown={showCityDropdown}
                onCurrentLocation={handleCurrentLocation}
                variant="compact"
              />
              {!isMobile && (
                <>
                  {/* Recommended Filter (DESKTOP) */}
                  {!isMobile && (
                    <div className="filter-group" style={{ position: 'relative', display: 'inline-block' }}>
                      <div
                        className={`more-dropdown-toggle ${recommendedRankedOnly || recommendedNotableArchitects || recommendedAppearsInGuide || recommendedAnyRecommended ? "active" : ""}`}
                        onClick={() => {
                          setRecommendedDropdownOpen((prev) => !prev);
                          setDropdownOpen(false);
                          setMoreDropdownOpen(false);
                          setArchitectDropdownOpen(false);
                          setMediaDropdownOpen(false);
                        }}
                      >
                        <span>Recommended</span>
                        <svg
                          className={`dropdown-caret ${recommendedDropdownOpen ? "open" : ""}`}
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                        >
                          <path d="M7 10l5 5 5-5z" fill="currentColor" />
                        </svg>
                      </div>
                      {recommendedDropdownOpen && (
                        <div className="more-dropdown-menu" style={{ position: 'absolute', left: 0, top: '100%', zIndex: 1000 }}>
                          <button className="dropdown-close" onClick={() => setRecommendedDropdownOpen(false)} aria-label="Close">×</button>
                          <div className="more-dropdown-title">Recommended</div>
                          <div className="more-option">
                            <div>
                              <input
                                type="checkbox"
                                id="recommended-any-recommended"
                                checked={recommendedAnyRecommended}
                                onChange={requireSignInOr(e => setRecommendedAnyRecommended(e.target.checked))}
                              />
                              <label htmlFor="recommended-any-recommended">Recommended Courses</label>
                            </div>
                            <div style={{ marginLeft: 24 }}>
                              <input
                                type="checkbox"
                                id="recommended-ranked-only"
                                checked={recommendedRankedOnly}
                                onChange={requireSignInOr(e => setRecommendedRankedOnly(e.target.checked))}
                              />
                              <label htmlFor="recommended-ranked-only">Ranked Courses</label>
                            </div>
                            <div style={{ marginLeft: 24 }}>
                              <input
                                type="checkbox"
                                id="recommended-notable-architects"
                                checked={recommendedNotableArchitects}
                                onChange={requireSignInOr(e => setRecommendedNotableArchitects(e.target.checked))}
                              />
                              <label htmlFor="recommended-notable-architects">Notable Architects</label>
                            </div>
                            <div style={{ marginLeft: 24 }}>
                              <input
                                type="checkbox"
                                id="recommended-appears-in-guide"
                                checked={recommendedAppearsInGuide}
                                onChange={requireSignInOr(e => setRecommendedAppearsInGuide(e.target.checked))}
                              />
                              <label htmlFor="recommended-appears-in-guide">Guide Recommended</label>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  <div className="filter-group desktop-only">
                    <div
                      className={`price-dropdown-toggle ${dropdownOpen || minPrice !== null || maxPrice !== null ? "active" : ""}`}
                      onClick={() => {
                        setDropdownOpen((prev) => !prev);
                        setMoreDropdownOpen(false);
                        setArchitectDropdownOpen(false);
                        setMediaDropdownOpen(false);
                        setRecommendedDropdownOpen(false);
                        setRecommendedDropdownOpenMobile(false);
                      }}
                    >
                      <span>
                        {minPrice !== null && maxPrice !== null
                          ? `$${minPrice} – $${maxPrice}`
                          : minPrice !== null
                          ? `$${minPrice}+`
                          : maxPrice !== null
                          ? `$0 – $${maxPrice}`
                          : "Price"}
                      </span>
                      <svg
                        className={`dropdown-caret ${dropdownOpen ? "open" : ""}`}
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                      >
                        <path d="M7 10l5 5 5-5z" fill="currentColor" />
                      </svg>
                    </div>
                    {!isMobile && dropdownOpen && (
                      <div className="price-dropdown-menu">
                        <button className="dropdown-close" onClick={() => setDropdownOpen(false)} aria-label="Close">×</button>
                        <label htmlFor="min-price-select">Min Price</label>
                        <select
                          id="min-price-select"
                          value={minPrice === null ? '' : minPrice}
                          onChange={requireSignInOr(e => setMinPrice(e.target.value === '' ? null : Number(e.target.value)))}
                        >
                          <option value="">No Min</option>
                          <option value="0">$0</option>
                          <option value="10">$10</option>
                          <option value="20">$20</option>
                          <option value="30">$30</option>
                          <option value="40">$40</option>
                          <option value="50">$50</option>
                          <option value="60">$60</option>
                          <option value="70">$70</option>
                          <option value="80">$80</option>
                          <option value="90">$90</option>
                          <option value="100">$100</option>
                          <option value="125">$125</option>
                          <option value="150">$150</option>
                          <option value="175">$175</option>
                          <option value="200">$200</option>
                          <option value="250">$250</option>
                          <option value="300">$300+</option>
                        </select>
                        <label htmlFor="max-price-select">Max Price</label>
                        <select
                          id="max-price-select"
                          value={maxPrice === null ? '' : maxPrice}
                          onChange={requireSignInOr(e => setMaxPrice(e.target.value === '' ? null : Number(e.target.value)))}
                        >
                          <option value="">No Max</option>
                          <option value="10">$10</option>
                          <option value="20">$20</option>
                          <option value="30">$30</option>
                          <option value="40">$40</option>
                          <option value="50">$50</option>
                          <option value="60">$60</option>
                          <option value="70">$70</option>
                          <option value="80">$80</option>
                          <option value="90">$90</option>
                          <option value="100">$100</option>
                          <option value="125">$125</option>
                          <option value="150">$150</option>
                          <option value="175">$175</option>
                          <option value="200">$200</option>
                          <option value="250">$250</option>
                          <option value="300">$300+</option>
                        </select>
                        <button className="reset-button" onClick={() => { setMinPrice(null); setMaxPrice(null); }}>Reset</button>
                        <button className="apply-button" onClick={() => { setDropdownOpen(false); }}>Apply</button>
                      </div>
                    )}
                  </div>
                  <div className="filter-group desktop-only">
                    <div
                      className={`more-dropdown-toggle ${moreDropdownOpen || !isCourseTypeDefault ? "active" : ""}`}
                      onClick={() => {
                        setMoreDropdownOpen((prev) => !prev);
                        setDropdownOpen(false);
                        setArchitectDropdownOpen(false);
                        setMediaDropdownOpen(false);
                        setRecommendedDropdownOpen(false);
                        setRecommendedDropdownOpenMobile(false);
                      }}
                    >
                      <span>Course Type</span>
                      <svg
                        className={`dropdown-caret ${moreDropdownOpen ? "open" : ""}`}
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                      >
                        <path d="M7 10l5 5 5-5z" fill="currentColor" />
                      </svg>
                    </div>
                    {!isMobile && moreDropdownOpen && (
                      <div className="more-dropdown-menu" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                        <div style={{ position: 'sticky', top: 0, zIndex: 2, background: '#fff' }}>
                          <button className="dropdown-close" onClick={() => setMoreDropdownOpen(false)} aria-label="Close">×</button>
                          <div className="more-dropdown-title">Course Types</div>
                        </div>
                        <div className="select-buttons">
                          <button type="button" onClick={() => setSelectedTypes(["Public","Municipal","Semi-Private","Resort","University","Military","Private"])}>Select All</button>
                          <button type="button" onClick={() => setSelectedTypes([])}>Deselect All</button>
                        </div>
                        <div className="more-option">
                          {allTypes.map((type) => (
                            <div key={type}>
                              <input
                                type="checkbox"
                                id={`type-${type}`}
                                checked={selectedTypes.includes(type)}
                                onChange={(e) => handleTypeChange(type, e.target.checked)}
                              />
                              <label htmlFor={`type-${type}`}>{type}</label>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="filter-group desktop-only">
                    <div
                      className={`more-dropdown-toggle ${architectDropdownOpen || selectedArchitects.length > 0 ? "active" : ""}`}
                      onClick={() => {
                        const next = !architectDropdownOpen;
                        setArchitectDropdownOpen(next);
                        if (next) setArchitectSearch("");
                        if (!next) setArchitectSearch("");
                        setDropdownOpen(false);
                        setMoreDropdownOpen(false);
                        setMediaDropdownOpen(false);
                        setRecommendedDropdownOpen(false);
                        setRecommendedDropdownOpenMobile(false);
                      }}
                    >
                      <span>Architect{selectedArchitects.length > 0 ? ` (${selectedArchitects.length})` : ""}</span>
                      <svg
                        className={`dropdown-caret ${architectDropdownOpen ? "open" : ""}`}
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                      >
                        <path d="M7 10l5 5 5-5z" fill="currentColor" />
                      </svg>
                    </div>
                    {!isMobile && architectDropdownOpen && (
                      <div className="more-dropdown-menu" style={{ maxHeight: 300, overflowY: 'auto', minWidth: 220, zIndex: 1000 }}>
                        <button className="dropdown-close" onClick={() => setArchitectDropdownOpen(false)} aria-label="Close">×</button>
                        <div style={{ position: 'relative', marginBottom: 10, width: '100%' }}>
                          <input
                            type="text"
                            placeholder="Search architects..."
                            value={architectSearch === "__SHOW_SELECTED__" ? "" : architectSearch}
                            onChange={e => setArchitectSearch(e.target.value)}
                            style={{ width: '82%', padding: '6px 32px 6px 8px', borderRadius: 6, border: '1px solid #ccc', fontSize: 14 }}
                            disabled={architectSearch === "__SHOW_SELECTED__"}
                          />
                          {architectSearch && architectSearch !== "__SHOW_SELECTED__" && (
                            <button
                              onClick={e => {
                                e.stopPropagation();
                                setArchitectSearch("");
                              }}
                              style={{
                                position: 'absolute',
                                right: 8,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: '#e0e0e0',
                                border: 'none',
                                borderRadius: '50%',
                                width: 22,
                                height: 22,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: 16,
                                cursor: 'pointer',
                                color: '#888',
                                lineHeight: 1,
                                padding: 0
                              }}
                              tabIndex={-1}
                              aria-label="Clear search"
                            >
                              ×
                            </button>
                          )}
                        </div>
                        <button
                          type="button"
                          onClick={() => setArchitectSearch(architectSearch === "__SHOW_SELECTED__" ? "" : "__SHOW_SELECTED__")}
                          style={{
                            width: '100%',
                            padding: '6px 12px',
                            marginBottom: 10,
                            background: architectSearch === "__SHOW_SELECTED__" ? '#e4f8ec' : '#f0f0f0',
                            border: '1px solid #ccc',
                            borderRadius: 6,
                            cursor: 'pointer',
                            fontSize: 14
                          }}
                        >
                          {architectSearch === "__SHOW_SELECTED__" ? "Show All" : "View Selected"}
                        </button>
                        <div className="select-buttons" style={{ marginBottom: 10 }}>
                          <button
                            type="button"
                            onClick={() => {
                              const filtered = architectOptions.filter(arch => arch.toLowerCase().includes(architectSearch.toLowerCase()));
                              setSelectedArchitects(prev => Array.from(new Set([...prev, ...filtered])));
                            }}
                          >
                            Select All
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              const filtered = architectOptions.filter(arch => arch.toLowerCase().includes(architectSearch.toLowerCase()));
                              setSelectedArchitects(prev => prev.filter(a => !filtered.includes(a)));
                            }}
                          >
                            Deselect All
                          </button>
                        </div>
                        <div className="more-dropdown-title">Architects</div>
                        <div className="more-option">
                          {(architectSearch === "__SHOW_SELECTED__"
                            ? architectOptions.filter(arch => selectedArchitects.includes(arch))
                            : architectOptions.filter(arch => arch.toLowerCase().includes(architectSearch.toLowerCase()))
                          ).map((arch) => (
                            <div key={arch} style={selectedArchitects.includes(arch) ? { background: '#e4f8ec', borderRadius: 6 } : {}}>
                              <input
                                type="checkbox"
                                id={`arch-${arch}`}
                                checked={selectedArchitects.includes(arch)}
                                onChange={requireSignInOr(e => {
                                  if (e.target.checked) {
                                    setSelectedArchitects(prev => [...prev, arch]);
                                  } else {
                                    setSelectedArchitects(prev => prev.filter(a => a !== arch));
                                  }
                                })}
                              />
                              <label htmlFor={`arch-${arch}`}>{arch}</label>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Other Filter (DESKTOP) */}
                  {!isMobile && (
                    <div className="filter-group desktop-only">
                      <div
                        className={`more-dropdown-toggle ${mediaDropdownOpen || hasMediaOnly || selectedMediaTypes.length > 0 || top100AllOnly || top100PublicOnly ? "active" : ""}`}
                        style={{ marginLeft: 8 }}
                        onClick={() => {
                          setMediaDropdownOpen((prev) => !prev);
                          setDropdownOpen(false);
                          setMoreDropdownOpen(false);
                          setArchitectDropdownOpen(false);
                          setRecommendedDropdownOpen(false);
                          setRecommendedDropdownOpenMobile(false);
                        }}
                      >
                        <span>Other</span>
                        <svg
                          className={`dropdown-caret ${mediaDropdownOpen ? "open" : ""}`}
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                        >
                          <path d="M7 10l5 5 5-5z" fill="currentColor" />
                        </svg>
                      </div>
                      {mediaDropdownOpen && (
                        <div className="more-dropdown-menu">
                          <button className="dropdown-close" onClick={() => setMediaDropdownOpen(false)} aria-label="Close">×</button>
                          <div className="more-dropdown-title">Other</div>
                          <div className="select-buttons">
                            <button type="button" onClick={() => {
                              setSelectedMediaTypes(featuredMediaTypes);
                              setTop100AllOnly(true);
                              setTop100PublicOnly(true);
                            }}>Select All</button>
                            <button type="button" onClick={() => {
                              setSelectedMediaTypes([]);
                              setTop100AllOnly(false);
                              setTop100PublicOnly(false);
                            }}>Deselect All</button>
                          </div>
                          <div className="more-option">
                            <div>
                              <input
                                type="checkbox"
                                id="has-media"
                                checked={hasMediaOnly}
                                onChange={requireSignInOr(e => setHasMediaOnly(e.target.checked))}
                              />
                              <label htmlFor="has-media">Courses with Media</label>
                            </div>
                          </div>
                          <div className="more-dropdown-divider"></div>
                          <div style={{ fontWeight: 600, margin: '8px 0 4px 0', fontSize: 14 }}>Featured Media</div>
                          <div className="more-option">
                            {featuredMediaTypes.map((type) => (
                              <div key={type}>
                                <input
                                  type="checkbox"
                                  id={`media-${type}`}
                                  checked={selectedMediaTypes.includes(type)}
                                  onChange={requireSignInOr(e => {
                                    if (e.target.checked) {
                                      setSelectedMediaTypes(prev => [...prev, type]);
                                    } else {
                                      setSelectedMediaTypes(prev => prev.filter(t => t !== type));
                                    }
                                  })}
                                />
                                <label htmlFor={`media-${type}`}>{type}</label>
                              </div>
                            ))}
                          </div>
                          <div className="more-dropdown-divider"></div>
                          <div style={{ fontWeight: 600, margin: '8px 0 4px 0', fontSize: 14 }}>Top Courses</div>
                          <div className="more-option">
                            <div>
                              <input
                                type="checkbox"
                                id="top100-all"
                                checked={top100AllOnly}
                                onChange={requireSignInOr(e => setTop100AllOnly(e.target.checked))}
                              />
                              <label htmlFor="top100-all">Golf Digest Top 100 Courses in America</label>
                            </div>
                            <div>
                              <input
                                type="checkbox"
                                id="top100-public"
                                checked={top100PublicOnly}
                                onChange={requireSignInOr(e => setTop100PublicOnly(e.target.checked))}
                              />
                              <label htmlFor="top100-public">Golf Digest Top 100 Public Courses in America</label>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {/* Recommended Filter (MOBILE) */}
                  {isMobile && (
                    <div className="filter-group mobile-visible">
                      <div
                        className={`more-dropdown-toggle ${recommendedDropdownOpenMobile || recommendedRankedOnly || recommendedNotableArchitects || recommendedAppearsInGuide || recommendedAnyRecommended ? "active" : ""}`}
                        onClick={() => {
                          setRecommendedDropdownOpenMobile((prev) => !prev);
                          setDropdownOpen(false);
                          setMoreDropdownOpen(false);
                          setArchitectDropdownOpen(false);
                          setMediaDropdownOpen(false);
                        }}
                      >
                        <span>Recommended</span>
                        <svg
                          className={`dropdown-caret ${recommendedDropdownOpenMobile ? "open" : ""}`}
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                        >
                          <path d="M7 10l5 5 5-5z" fill="currentColor" />
                        </svg>
                      </div>
                      {recommendedDropdownOpenMobile && (
                        <div className="more-dropdown-menu">
                          <div style={{ position: 'sticky', top: 0, zIndex: 2, background: '#fff' }}>
                            <button className="dropdown-close" onClick={() => setRecommendedDropdownOpenMobile(false)} aria-label="Close">×</button>
                            <div className="more-dropdown-title">Recommended</div>
                          </div>
                          <div className="more-option">
                            <div>
                              <input
                                type="checkbox"
                                id="recommended-any-recommended-mobile"
                                checked={recommendedAnyRecommended}
                                onChange={requireSignInOr(e => setRecommendedAnyRecommended(e.target.checked))}
                              />
                              <label htmlFor="recommended-any-recommended-mobile">Recommended Courses</label>
                            </div>
                            <div style={{ marginLeft: 24 }}>
                              <input
                                type="checkbox"
                                id="recommended-ranked-only-mobile"
                                checked={recommendedRankedOnly}
                                onChange={requireSignInOr(e => setRecommendedRankedOnly(e.target.checked))}
                              />
                              <label htmlFor="recommended-ranked-only-mobile">Ranked Courses</label>
                            </div>
                            <div style={{ marginLeft: 24 }}>
                              <input
                                type="checkbox"
                                id="recommended-notable-architects-mobile"
                                checked={recommendedNotableArchitects}
                                onChange={requireSignInOr(e => setRecommendedNotableArchitects(e.target.checked))}
                              />
                              <label htmlFor="recommended-notable-architects-mobile">Notable Architects</label>
                            </div>
                            <div style={{ marginLeft: 24 }}>
                              <input
                                type="checkbox"
                                id="recommended-appears-in-guide-mobile"
                                checked={recommendedAppearsInGuide}
                                onChange={requireSignInOr(e => setRecommendedAppearsInGuide(e.target.checked))}
                              />
                              <label htmlFor="recommended-appears-in-guide-mobile">Guide Recommended</label>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
            <div className="top-bar-right">
              {/* Removed Home button here */}
            </div>
          </div>
          {isMobile && (
            <>
              {isMobileMenuOpen && (
                <div className="mobile-filters-modal-overlay" onClick={() => setIsMobileMenuOpen(false)}>
                  <div className="mobile-filters-modal" onClick={e => e.stopPropagation()}>
                    <button className="mobile-filters-close" onClick={() => setIsMobileMenuOpen(false)} aria-label="Close filters">×</button>
                    <div className="mobile-filters-content" style={{ gap: 10 }}>
                      {/* Recommended Filter (MOBILE) */}
                      <div className="filter-group mobile-visible">
                        <div
                          className={`more-dropdown-toggle ${recommendedDropdownOpenMobile || recommendedRankedOnly || recommendedNotableArchitects || recommendedAppearsInGuide || recommendedAnyRecommended ? "active" : ""}`}
                          onClick={() => {
                            setRecommendedDropdownOpenMobile((prev) => !prev);
                            setDropdownOpen(false);
                            setMoreDropdownOpen(false);
                            setArchitectDropdownOpen(false);
                            setMediaDropdownOpen(false);
                          }}
                        >
                          <span>Recommended</span>
                          <svg
                            className={`dropdown-caret ${recommendedDropdownOpenMobile ? "open" : ""}`}
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                          >
                            <path d="M7 10l5 5 5-5z" fill="currentColor" />
                          </svg>
                        </div>
                        {recommendedDropdownOpenMobile && (
                          <div className="more-dropdown-menu">
                            <div style={{ position: 'sticky', top: 0, zIndex: 2, background: '#fff' }}>
                              <button className="dropdown-close" onClick={() => setRecommendedDropdownOpenMobile(false)} aria-label="Close">×</button>
                              <div className="more-dropdown-title">Recommended</div>
                            </div>
                            <div className="more-option">
                              <div>
                                <input
                                  type="checkbox"
                                  id="recommended-any-recommended-mobile"
                                  checked={recommendedAnyRecommended}
                                  onChange={requireSignInOr(e => setRecommendedAnyRecommended(e.target.checked))}
                                />
                                <label htmlFor="recommended-any-recommended-mobile">Recommended Courses</label>
                              </div>
                              <div style={{ marginLeft: 24 }}>
                                <input
                                  type="checkbox"
                                  id="recommended-ranked-only-mobile"
                                  checked={recommendedRankedOnly}
                                  onChange={requireSignInOr(e => setRecommendedRankedOnly(e.target.checked))}
                                />
                                <label htmlFor="recommended-ranked-only-mobile">Ranked Courses</label>
                              </div>
                              <div style={{ marginLeft: 24 }}>
                                <input
                                  type="checkbox"
                                  id="recommended-notable-architects-mobile"
                                  checked={recommendedNotableArchitects}
                                  onChange={requireSignInOr(e => setRecommendedNotableArchitects(e.target.checked))}
                                />
                                <label htmlFor="recommended-notable-architects-mobile">Notable Architects</label>
                              </div>
                              <div style={{ marginLeft: 24 }}>
                                <input
                                  type="checkbox"
                                  id="recommended-appears-in-guide-mobile"
                                  checked={recommendedAppearsInGuide}
                                  onChange={requireSignInOr(e => setRecommendedAppearsInGuide(e.target.checked))}
                                />
                                <label htmlFor="recommended-appears-in-guide-mobile">Guide Recommended</label>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      {/* Price Filter */}
                      <div className="filter-group mobile-visible">
                        <div
                          className={`price-dropdown-toggle ${dropdownOpen || minPrice !== null || maxPrice !== null ? "active" : ""}`}
                          onClick={() => {
                            setDropdownOpen((prev) => !prev);
                            setMoreDropdownOpen(false);
                            setArchitectDropdownOpen(false);
                            setMediaDropdownOpen(false);
                            setRecommendedDropdownOpen(false);
                            setRecommendedDropdownOpenMobile(false);
                          }}
                        >
                          <span>
                            {minPrice !== null && maxPrice !== null
                              ? `$${minPrice} – $${maxPrice}`
                              : minPrice !== null
                              ? `$${minPrice}+`
                              : maxPrice !== null
                              ? `$0 – $${maxPrice}`
                              : "Price"}
                          </span>
                          <svg
                            className={`dropdown-caret ${dropdownOpen ? "open" : ""}`}
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                          >
                            <path d="M7 10l5 5 5-5z" fill="currentColor" />
                          </svg>
                        </div>
                        {dropdownOpen && (
                          <div className="price-dropdown-menu">
                            <div style={{ position: 'sticky', top: 0, zIndex: 2, background: '#fff' }}>
                              <button className="dropdown-close" onClick={() => setDropdownOpen(false)} aria-label="Close">×</button>
                              <label htmlFor="min-price-select-mobile">Min Price</label>
                            </div>
                            <select
                              id="min-price-select-mobile"
                              value={minPrice === null ? '' : minPrice}
                              onChange={requireSignInOr(e => setMinPrice(e.target.value === '' ? null : Number(e.target.value)))}
                            >
                              <option value="">No Min</option>
                              <option value="0">$0</option>
                              <option value="10">$10</option>
                              <option value="20">$20</option>
                              <option value="30">$30</option>
                              <option value="40">$40</option>
                              <option value="50">$50</option>
                              <option value="60">$60</option>
                              <option value="70">$70</option>
                              <option value="80">$80</option>
                              <option value="90">$90</option>
                              <option value="100">$100</option>
                              <option value="125">$125</option>
                              <option value="150">$150</option>
                              <option value="175">$175</option>
                              <option value="200">$200</option>
                              <option value="250">$250</option>
                              <option value="300">$300+</option>
                            </select>
                            <label htmlFor="max-price-select-mobile">Max Price</label>
                            <select
                              id="max-price-select-mobile"
                              value={maxPrice === null ? '' : maxPrice}
                              onChange={requireSignInOr(e => setMaxPrice(e.target.value === '' ? null : Number(e.target.value)))}
                            >
                              <option value="">No Max</option>
                              <option value="10">$10</option>
                              <option value="20">$20</option>
                              <option value="30">$30</option>
                              <option value="40">$40</option>
                              <option value="50">$50</option>
                              <option value="60">$60</option>
                              <option value="70">$70</option>
                              <option value="80">$80</option>
                              <option value="90">$90</option>
                              <option value="100">$100</option>
                              <option value="125">$125</option>
                              <option value="150">$150</option>
                              <option value="175">$175</option>
                              <option value="200">$200</option>
                              <option value="250">$250</option>
                              <option value="300">$300+</option>
                            </select>
                            <button className="reset-button" onClick={() => { setMinPrice(null); setMaxPrice(null); }}>Reset</button>
                            <button className="apply-button" onClick={() => { setDropdownOpen(false); }}>Apply</button>
                          </div>
                        )}
                      </div>
                      {/* Course Type Filter */}
                      <div className="filter-group mobile-visible">
                        <div
                          className={`more-dropdown-toggle ${moreDropdownOpen || !isCourseTypeDefault ? "active" : ""}`}
                          onClick={() => {
                            setMoreDropdownOpen((prev) => !prev);
                            setDropdownOpen(false);
                            setArchitectDropdownOpen(false);
                            setMediaDropdownOpen(false);
                            setRecommendedDropdownOpen(false);
                            setRecommendedDropdownOpenMobile(false);
                          }}
                        >
                          <span>Course Type</span>
                          <svg
                            className={`dropdown-caret ${moreDropdownOpen ? "open" : ""}`}
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                          >
                            <path d="M7 10l5 5 5-5z" fill="currentColor" />
                          </svg>
                        </div>
                        {moreDropdownOpen && (
                          <div className="more-dropdown-menu" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                            <div style={{ position: 'sticky', top: 0, zIndex: 2, background: '#fff' }}>
                              <button className="dropdown-close" onClick={() => setMoreDropdownOpen(false)} aria-label="Close">×</button>
                              <div className="more-dropdown-title">Course Types</div>
                            </div>
                            <div className="select-buttons">
                              <button type="button" onClick={() => setSelectedTypes(["Public","Municipal","Semi-Private","Resort","University","Military","Private"])}>Select All</button>
                              <button type="button" onClick={() => setSelectedTypes([])}>Deselect All</button>
                            </div>
                            <div className="more-option">
                              {allTypes.map((type) => (
                                <div key={type}>
                                  <input
                                    type="checkbox"
                                    id={`type-mobile-${type}`}
                                    checked={selectedTypes.includes(type)}
                                    onChange={(e) => handleTypeChange(type, e.target.checked)}
                                  />
                                  <label htmlFor={`type-mobile-${type}`}>{type}</label>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                      {/* Architect Filter */}
                      <div className="filter-group mobile-visible">
                        <div
                          className={`more-dropdown-toggle ${architectDropdownOpen || selectedArchitects.length > 0 ? "active" : ""}`}
                          onClick={() => {
                            const next = !architectDropdownOpen;
                            setArchitectDropdownOpen(next);
                            if (next) setArchitectSearch("");
                            if (!next) setArchitectSearch("");
                            setDropdownOpen(false);
                            setMoreDropdownOpen(false);
                            setMediaDropdownOpen(false);
                            setRecommendedDropdownOpen(false);
                            setRecommendedDropdownOpenMobile(false);
                          }}
                        >
                          <span>Architect{selectedArchitects.length > 0 ? ` (${selectedArchitects.length})` : ""}</span>
                          <svg
                            className={`dropdown-caret ${architectDropdownOpen ? "open" : ""}`}
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                          >
                            <path d="M7 10l5 5 5-5z" fill="currentColor" />
                          </svg>
                        </div>
                        {architectDropdownOpen && (
                          <div className="more-dropdown-menu" style={{ maxHeight: 300, overflowY: 'auto', minWidth: 220, zIndex: 1000 }}>
                            <div style={{ position: 'sticky', top: 0, zIndex: 2, background: '#fff' }}>
                              <button className="dropdown-close" onClick={() => setArchitectDropdownOpen(false)} aria-label="Close">×</button>
                              <div className="more-dropdown-title">Architects</div>
                            </div>
                            <div style={{ position: 'relative', marginBottom: 10, width: '100%' }}>
                              <input
                                type="text"
                                placeholder="Search architects..."
                                value={architectSearch === "__SHOW_SELECTED__" ? "" : architectSearch}
                                onChange={e => setArchitectSearch(e.target.value)}
                                style={{ width: '82%', padding: '6px 32px 6px 8px', borderRadius: 6, border: '1px solid #ccc', fontSize: 14 }}
                                disabled={architectSearch === "__SHOW_SELECTED__"}
                              />
                              {architectSearch && architectSearch !== "__SHOW_SELECTED__" && (
                                <button
                                  onClick={e => {
                                    e.stopPropagation();
                                    setArchitectSearch("");
                                  }}
                                  style={{
                                    position: 'absolute',
                                    right: 8,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: '#e0e0e0',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: 22,
                                    height: 22,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: 16,
                                    cursor: 'pointer',
                                    color: '#888',
                                    lineHeight: 1,
                                    padding: 0
                                  }}
                                  tabIndex={-1}
                                  aria-label="Clear search"
                                >
                                  ×
                                </button>
                              )}
                            </div>
                            <button
                              type="button"
                              onClick={() => setArchitectSearch(architectSearch === "__SHOW_SELECTED__" ? "" : "__SHOW_SELECTED__")}
                              style={{
                                width: '100%',
                                padding: '6px 12px',
                                marginBottom: 10,
                                background: architectSearch === "__SHOW_SELECTED__" ? '#e4f8ec' : '#f0f0f0',
                                border: '1px solid #ccc',
                                borderRadius: 6,
                                cursor: 'pointer',
                                fontSize: 14
                              }}
                            >
                              {architectSearch === "__SHOW_SELECTED__" ? "Show All" : "View Selected"}
                            </button>
                            <div className="select-buttons" style={{ marginBottom: 10 }}>
                              <button
                                type="button"
                                onClick={() => {
                                  const filtered = architectOptions.filter(arch => arch.toLowerCase().includes(architectSearch.toLowerCase()));
                                  setSelectedArchitects(prev => Array.from(new Set([...prev, ...filtered])));
                                }}
                              >
                                Select All
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  const filtered = architectOptions.filter(arch => arch.toLowerCase().includes(architectSearch.toLowerCase()));
                                  setSelectedArchitects(prev => prev.filter(a => !filtered.includes(a)));
                                }}
                              >
                                Deselect All
                              </button>
                            </div>
                            <div className="more-option">
                              {(architectSearch === "__SHOW_SELECTED__"
                                ? architectOptions.filter(arch => selectedArchitects.includes(arch))
                                : architectOptions.filter(arch => arch.toLowerCase().includes(architectSearch.toLowerCase()))
                              ).map((arch) => (
                                <div key={arch} style={selectedArchitects.includes(arch) ? { background: '#e4f8ec', borderRadius: 6 } : {}}>
                                  <input
                                    type="checkbox"
                                    id={`arch-mobile-${arch}`}
                                    checked={selectedArchitects.includes(arch)}
                                    onChange={requireSignInOr(e => {
                                      if (e.target.checked) {
                                        setSelectedArchitects(prev => [...prev, arch]);
                                      } else {
                                        setSelectedArchitects(prev => prev.filter(a => a !== arch));
                                      }
                                    })}
                                  />
                                  <label htmlFor={`arch-mobile-${arch}`}>{arch}</label>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                      {/* Media Filter */}
                      <div className="filter-group mobile-visible">
                        <div
                          className={`more-dropdown-toggle ${mediaDropdownOpen || hasMediaOnly || selectedMediaTypes.length > 0 || top100AllOnly || top100PublicOnly ? "active" : ""}`}
                          onClick={() => {
                            setMediaDropdownOpen((prev) => !prev);
                            setDropdownOpen(false);
                            setMoreDropdownOpen(false);
                            setArchitectDropdownOpen(false);
                            setRecommendedDropdownOpen(false);
                            setRecommendedDropdownOpenMobile(false);
                          }}
                        >
                          <span>Other</span>
                          <svg
                            className={`dropdown-caret ${mediaDropdownOpen ? "open" : ""}`}
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                          >
                            <path d="M7 10l5 5 5-5z" fill="currentColor" />
                          </svg>
                        </div>
                        {mediaDropdownOpen && (
                          <div className="more-dropdown-menu">
                            <div style={{ position: 'sticky', top: 0, zIndex: 2, background: '#fff' }}>
                              <button className="dropdown-close" onClick={() => setMediaDropdownOpen(false)} aria-label="Close">×</button>
                              <div className="more-dropdown-title">Other</div>
                            </div>
                            <div className="select-buttons">
                              <button type="button" onClick={() => {
                                setSelectedMediaTypes(featuredMediaTypes);
                                setTop100AllOnly(true);
                                setTop100PublicOnly(true);
                              }}>Select All</button>
                              <button type="button" onClick={() => {
                                setSelectedMediaTypes([]);
                                setTop100AllOnly(false);
                                setTop100PublicOnly(false);
                              }}>Deselect All</button>
                            </div>
                            <div className="more-option">
                              <div>
                                <input
                                  type="checkbox"
                                  id="has-media-mobile"
                                  checked={hasMediaOnly}
                                  onChange={requireSignInOr(e => setHasMediaOnly(e.target.checked))}
                                />
                                <label htmlFor="has-media-mobile">Courses with Media</label>
                              </div>
                            </div>
                            <div className="more-dropdown-divider"></div>
                            <div style={{ fontWeight: 600, margin: '8px 0 4px 0', fontSize: 14 }}>Featured Media</div>
                            <div className="more-option">
                              {featuredMediaTypes.map((type) => (
                                <div key={type}>
                                  <input
                                    type="checkbox"
                                    id={`media-mobile-${type}`}
                                    checked={selectedMediaTypes.includes(type)}
                                    onChange={requireSignInOr(e => {
                                      if (e.target.checked) {
                                        setSelectedMediaTypes(prev => [...prev, type]);
                                      } else {
                                        setSelectedMediaTypes(prev => prev.filter(t => t !== type));
                                      }
                                    })}
                                  />
                                  <label htmlFor={`media-mobile-${type}`}>{type}</label>
                                </div>
                              ))}
                            </div>
                            <div className="more-dropdown-divider"></div>
                            <div style={{ fontWeight: 600, margin: '8px 0 4px 0', fontSize: 14 }}>Top Courses</div>
                            <div className="more-option">
                              <div>
                                <input
                                  type="checkbox"
                                  id="top100-all-mobile"
                                  checked={top100AllOnly}
                                  onChange={requireSignInOr(e => setTop100AllOnly(e.target.checked))}
                                />
                                <label htmlFor="top100-all-mobile">Golf Digest Top 100 Courses in America</label>
                              </div>
                              <div>
                                <input
                                  type="checkbox"
                                  id="top100-public-mobile"
                                  checked={top100PublicOnly}
                                  onChange={requireSignInOr(e => setTop100PublicOnly(e.target.checked))}
                                />
                                <label htmlFor="top100-public-mobile">Golf Digest Top 100 Public Courses in America</label>
                              </div>
                            </div>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
          <div className="main-content">
            {listCourseIds.length > 0 && (
              <div style={{
                position: 'absolute',
                top: '10px',
                left: '50%',
                transform: 'translateX(-50%)',
                background: '#1D665D',
                color: 'white',
                padding: '8px 16px',
                borderRadius: '20px',
                fontSize: '14px',
                fontWeight: '600',
                zIndex: 1000,
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
              }}>
                <span>📋 {listName}</span>
                {searchParams.get('user') && searchParams.get('user') !== user?.uid && (
                  <span style={{ fontSize: '12px', opacity: 0.8 }}>(Shared)</span>
                )}
                <button
                  onClick={() => {
                    setListCourseIds([]);
                    setListName('');
                    // Clear URL parameters
                    const newSearchParams = new URLSearchParams(searchParams);
                    newSearchParams.delete('list');
                    newSearchParams.delete('type');
                    newSearchParams.delete('user');
                    newSearchParams.delete('listId');
                    newSearchParams.delete('courseIds');
                    newSearchParams.delete('listName');
                    setSearchParams(newSearchParams);
                    // Clear session storage for this list
                    const listParam = searchParams.get('list');
                    if (listParam && listParam.startsWith('list_')) {
                      sessionStorage.removeItem(listParam);
                    }
                  }}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: '16px',
                    padding: '0',
                    margin: '0',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  ×
                </button>
              </div>
            )}
            <div 
              ref={mapRef} 
              className="map-container"
            />
            <MarkerTooltip 
              tooltipInfo={tooltipInfo}
              isMobile={isMobile}
              onTitleClick={course => {
                if (isMobile) {
                  // On mobile, navigate to course page
                  window.open(`/course/${course.course_id}`, '_blank');
                } else {
                  // On desktop, show featured card
                  handleProtectedInteraction(() => setSelectedCourse(course));
                }
              }}
              courseGuides={courseGuides}

              onMouseLeave={() => {
                if (tooltipTimeoutRef.current) {
                  clearTimeout(tooltipTimeoutRef.current);
                  tooltipTimeoutRef.current = null;
                }
                // Immediately hide non-sticky tooltips when mouse leaves tooltip (like SpecializedMap)
                if (tooltipInfo && !tooltipInfo.sticky) {
                  setTooltipInfo(null);
                }
              }}
            />
            <div 
              className="sidebar"
            >
              <div className="featured-container">
                {selectedCourse && !isMobile ? (
                  <FeaturedCard
                    course={selectedCourse}
                    onClose={() => {
                      if (selectedCourse && markersRef.current[selectedCourse.course_id]) {
                        const el = markersRef.current[selectedCourse.course_id].element;
                        const photoUrl = selectedCourse.photo_url;
                        // Direct DOM manipulation like SpecializedMap
                        el.style.boxShadow = photoUrl ? "0 2px 8px rgba(0,0,0,0.18)" : "0 2px 8px rgba(0,0,0,0.18)";
                      }
                      setSelectedCourse(null);
                      setTooltipInfo(null);
                    }}
                    markersRef={markersRef}
                    clusters={clusters}
                    user={user}
                    playedCourses={playedCourses}
                    onPlayedChange={handlePlayedChange}
                    wishlistCourses={wishlistCourses}
                    onWishlistChange={handleWishlistChange}
                    findClusterForCourse={findClusterForCourse}
                    getMarkerElementForCourse={getMarkerElementForCourse}
                    isMobile={false}
                    courseGuides={courseGuides}
                  />
                ) : null}
              </div>

              <div className="scrollable-list">
                <div className="course-grid">
                  {sidebarCourses.map((course, index) => {
                    return (
                      <div
                        key={course.course_id || course.name || index}
                        className={`course-card ${hoveredCourse === course.name ? "hovered-sidebar" : ""}`}
                        onClick={() => {
                          if (isMobile) {
                            // On mobile, show tooltip instead of featured card
                            const mapContainer = mapInstance.current.getContainer();
                            const mapRect = mapContainer.getBoundingClientRect();
                            const point = mapInstance.current.project([course.lng, course.lat]);
                            setTooltipInfo({
                              course: course,
                              position: {
                                x: point.x,
                                y: point.y - 4
                              },
                              sticky: true
                            });
                          } else {
                            // On desktop, show featured card
                            handleProtectedInteraction(() => setSelectedCourse(course));
                          }
                        }}
                        onMouseEnter={() => {
                          setHoveredCourse(course.name);
                          const markerElement = getMarkerElementForCourse(course);
                          if (markerElement && (!selectedCourse || selectedCourse.course_id !== course.course_id)) {
                            // Direct DOM manipulation like SpecializedMap
                            markerElement.style.boxShadow = "0 0 0 4px #1D665D, 0 2px 8px rgba(0,0,0,0.18)";
                            // Clear any existing timeout
                            if (tooltipTimeoutRef.current) {
                              clearTimeout(tooltipTimeoutRef.current);
                              tooltipTimeoutRef.current = null;
                            }
                            // Use proper screen coordinates for positioning
                            const rect = markerElement.getBoundingClientRect();
                            const mapContainer = mapInstance.current.getContainer();
                            const mapRect = mapContainer.getBoundingClientRect();
                            tooltipTimeoutRef.current = setTimeout(() => {
                              // Double-check that we still want to show the tooltip
                              if (!justClickedRef.current && !tooltipInfo?.sticky) {
                                setTooltipInfo({
                                course: course,
                                position: {
                                  x: rect.left - mapRect.left + rect.width / 2,
                                  y: rect.top - mapRect.top - 4
                                },
                                sticky: false
                              });
                              }
                            }, 200); // Match SpecializedMap exactly
                          }
                        }}
                        onMouseLeave={() => {
                          // Simple cleanup like SpecializedMap - no delays, just close immediately
                          setHoveredCourse(null);
                          const markerElement = getMarkerElementForCourse(course);
                          if (markerElement && (!selectedCourse || selectedCourse.course_id !== course.course_id)) {
                            // Direct DOM manipulation like SpecializedMap
                            markerElement.style.boxShadow = course.photo_url ? "0 2px 8px rgba(0,0,0,0.18)" : "0 2px 8px rgba(0,0,0,0.18)";
                          }
                          // Clear any pending tooltip timeout
                          if (tooltipTimeoutRef.current) {
                            clearTimeout(tooltipTimeoutRef.current);
                            tooltipTimeoutRef.current = null;
                          }
                          // Add delay to allow moving to tooltip (like SpecializedMap)
                          if (tooltipInfo && !tooltipInfo.sticky) {
                            tooltipTimeoutRef.current = setTimeout(() => {
                              setTooltipInfo(null);
                            }, 300); // Match SpecializedMap exactly
                          }
                        }}
                      >
                        {/* Course Name */}
                        <h3 style={{ 
                          fontWeight: '700', 
                          color: '#222', 
                          fontSize: '14px',
                          marginBottom: '4px',
                          wordBreak: 'break-word'
                        }}>
                          {course.name}
                        </h3>
                        
                        {/* Club Name */}
                        <div style={{ 
                          color: '#666', 
                          fontSize: '13px',
                          marginBottom: '6px',
                          fontStyle: 'italic'
                        }}>
                          {course.club_name}
                        </div>
                        
                        {/* State Ranking and Notable Architect Row */}
                        <div style={{ 
                          display: 'flex', 
                          flexWrap: 'wrap', 
                          gap: '8px', 
                          marginBottom: '8px',
                          fontSize: '12px',
                          color: '#1D665D',
                          fontWeight: '600'
                        }}>
                                                {course.GD100all_rank && course.GD100all_rank !== '' && (
                        <span>#{course.GD100all_rank} in America</span>
                      )}
                      {course.GD100pub_rank && course.GD100pub_rank !== '' && (
                        <>
                          {course.GD100all_rank && course.GD100all_rank !== '' && <span>•</span>}
                          <span>#{course.GD100pub_rank} Public in America</span>
                        </>
                      )}
                      {course.top100_state_rank && course.top100_state_rank !== '' && (
                        <>
                          {(course.GD100all_rank && course.GD100all_rank !== '') || (course.GD100pub_rank && course.GD100pub_rank !== '') ? <span>•</span> : null}
                          <span>#{course.top100_state_rank} in {course.state}</span>
                        </>
                      )}

                        </div>
                        
                        {/* Appears in Guide (if applicable) */}
                        {courseGuides.some(guide => guide.course_id === course.course_id) && (
                          <div style={{ 
                            color: '#1D665D', 
                            fontSize: '12px',
                            fontWeight: '600',
                            marginBottom: '4px'
                          }}>
                            Appears in{' '}
                            {courseGuides
                              .filter(guide => guide.course_id === course.course_id)
                              .filter((guide, index, self) => 
                                index === self.findIndex(g => g.guide === guide.guide)
                              )
                              .map((guide, index) => (
                                <span key={`${guide.course_id}-${guide.guide}-${index}`}>
                                  {index > 0 && ', '}
                                  <a 
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      const url = guide.link.match(/^https?:\/\//i) ? guide.link : `https://${guide.link}`;
                                      window.open(url, '_blank');
                                    }}
                                    style={{ color: '#1D665D', textDecoration: 'underline', cursor: 'pointer' }}
                                  >
                                    {guide.guide}
                                  </a>
                                </span>
                              ))}
                          </div>
                        )}
                        
                        {/* Details Row */}
                        <div style={{ 
                          color: '#555', 
                          fontSize: '12px',
                          display: 'flex',
                          flexWrap: 'wrap',
                          gap: '8px',
                          marginBottom: '8px'
                        }}>
                          <span>{course.type}</span>
                          <span>•</span>
                          <span>{course.open_date && course.open_date !== 'N/D' && course.open_date !== '' ? course.open_date : 'Year Unknown'}</span>
                          <span>•</span>
                          <span>{course.number_of_holes ? (course.number_of_holes >= 18 ? '18 Holes' : `${course.number_of_holes} Holes`) : 'Holes Unknown'}</span>
                          {course.course_architect && course.course_architect !== 'N/D' && course.course_architect !== '' && (
                            <>
                              <span>•</span>
                              <span style={{
                                fontWeight: course.notable_architect && course.notable_architect !== 'N' ? '700' : '400',
                                color: course.notable_architect && course.notable_architect !== 'N' ? '#1D665D' : '#555'
                              }}>
                                {course.course_architect}
                              </span>
                            </>
                          )}
                        </div>
                        

                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* ClusterHoverCard removed - simplifying to just use tooltips like the specialized map */}
          </div>
          <ContactModal 
            isOpen={isContactModalOpen} 
            onClose={() => setIsContactModalOpen(false)} 
          />
          <SignInPromptModal open={showSignInPrompt} onClose={() => setShowSignInPrompt(false)} />
        </div>
      } />
      <Route path="/course/:id" element={<CourseDetail golfCourses={golfCourses} user={user} playedCourses={playedCourses} playedLoading={playedLoading} onPlayedChange={handlePlayedChange} wishlistCourses={wishlistCourses} onWishlistChange={handleWishlistChange} courseGuides={courseGuides} onGuidesUpdated={refreshCourseGuides} />} />
      <Route path="/article/:slug" element={<ArticleDetail />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/login" element={<Login />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/cookies" element={<CookiesPolicy />} />
      <Route path="/user/:username" element={<PublicProfile />} />
    </Routes>
  );
}

function App() {
  const [user, setUser] = React.useState(null);
  const [isContactModalOpen, setIsContactModalOpen] = React.useState(false);

  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
    });
    return () => unsubscribe();
  }, []);

  const handleSignOut = async () => {
    await signOut(auth);
  };

  return (
    <HelmetProvider>
      <Router>
        <Helmet>
          <link href="https://fonts.googleapis.com/css2?family=Bodoni+Moda:wght@400;700&display=swap" rel="stylesheet" />
        </Helmet>
      {/* Navigation bar with Home on the left and Contact/Profile/Sign Out on the right */}
      <div className="top-bar" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, padding: 16, background: '#fff', borderBottom: '1px solid #eee', flexWrap: 'nowrap', position: 'relative', zIndex: 3001 }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Link
            to="/"
            style={{
              fontFamily: 'Bodoni Moda, serif',
              fontWeight: 400,
              fontSize: 'clamp(14px, 6vw, 32px)',
              color: '#1D665D',
              letterSpacing: '-0.03em',
              lineHeight: 1.05,
              marginLeft: -10,
              textDecoration: 'none',
              textShadow: '0 2px 8px rgba(0,0,0,0.03)',
              fontStretch: 'condensed',
              transform: 'scaleX(0.7)',
              userSelect: 'none',
              display: 'inline-block',
              verticalAlign: 'middle',
              minWidth: 0,
              flexShrink: 1,
              whiteSpace: 'nowrap',
            }}
            aria-label="Golf Near Me Home"
          >
            GOLF NEAR ME
          </Link>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          {user ? (
            <div className="user-avatar-container">
              <Link to="/profile" className="user-avatar">
                {(user.displayName || user.email || 'U').charAt(0)}
              </Link>
              <div className="user-dropdown">
                <Link to="/profile" className="user-dropdown-item">
                  View Profile
                </Link>
                <div className="user-dropdown-divider"></div>
                <button onClick={handleSignOut} className="user-dropdown-item">
                  Sign Out
                </button>
              </div>
            </div>
          ) : (
            <>
              <Link to="/signup" style={{ color: '#1D665D', fontWeight: 600, textDecoration: 'none', marginRight: 8 }}>Sign Up</Link>
              <Link to="/login" style={{ color: '#1D665D', fontWeight: 600, textDecoration: 'none', marginRight: 8 }}>Login</Link>
            </>
          )}
        </div>
      </div>
      {/* Sticky footer layout wrapper */}
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <AppRoutes user={user} setUser={setUser} />
        </div>
        {/* Footer with legal links */}
        <div style={{
          background: '#f8f9fa',
          borderTop: '1px solid #eee',
          padding: '24px 16px',
          marginTop: 'auto',
          textAlign: 'center'
        }}>
          <div style={{
            maxWidth: 1200,
            margin: '0 auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 24,
            flexWrap: 'wrap'
          }}>
            <Link to="/terms" style={{
              color: '#666',
              textDecoration: 'none',
              fontSize: 14,
              fontWeight: 500
            }}>
              Terms of Service
            </Link>
            <Link to="/privacy" style={{
              color: '#666',
              textDecoration: 'none',
              fontSize: 14,
              fontWeight: 500
            }}>
              Privacy Policy
            </Link>
            <Link to="/cookies" style={{
              color: '#666',
              textDecoration: 'none',
              fontSize: 14,
              fontWeight: 500
            }}>
              Cookies Policy
            </Link>
          </div>
          <div style={{
            marginTop: 12,
            fontSize: 12,
            color: '#999'
          }}>
            © 2025 RPK Production LLC. All rights reserved.
          </div>
        </div>
      </div>
      <ContactModal isOpen={isContactModalOpen} onClose={() => setIsContactModalOpen(false)} />
      </Router>
    </HelmetProvider>
  );
}

export default App;
